PJQ.views.addressbook = {};

PJQ.constants.addressBook = {
    approvalFilter: {
      APPROVED: -3,
      UNAPPROVED: -4
    },
    contactStatusFilter: {
      ACTIVE: -5,
      INACTIVE: -6
    },
    directoryFilter: {
        ALL_CONTACTS: 0,
        PRIVATE_ONLY: -1,
        PUBLIC_ONLY: -2
    },
    laborStatusFilter: {
        UNION: -7,
        NON_UNION: -8,
        PREV_WAGE: -9,
        NOT_AVAILABLE: -10
    },
    miscFilter: {
        PRIMARY_CONTACT_ONLY: -11
    },
    locationTypeFilter: {
        WORK_AREA: 1,
        OFFICE_LOCATION: 2,
        BOTH: 3
    },
    view: {
        TRADES_COMPANY: 'groupcompany',
        TRADES_COMPANY_GROUP: 'groupcompany-group',
        TRADES_COMPANY_COMPANY: 'groupcompany-company',
        TRADES_COMPANY_COMPANY_CONTACT: 'groupcompany-company-contact',
        TRADES_CONTACT: 'groupcontact',
        TRADES_CONTACT_GROUP: 'groupcontact-group',
        TRADES_CONTACT_CONTACT: 'groupcontact-contact',
        COMPANY: 'company',
        COMPANY_CONTACT: 'company-contact',
        CONTACT: 'contact',
        CONTACT_GROUP: 'contactgroup'
    },
    selectionMode: {
        NONE: 'none',
        PROQUAL: 'proqual',
        MERGE: 'merge',
        ADD_TO_PROJECT: 'addToProject',
        UPDATER: 'updater'
    }
};

if (PJQ.app.module === PJQ.constants.modules.ADDRESSBOOK) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('contacts', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.addressBook = {
    routes: [
        {
            route: 'contacts/:contactId',
            name: 'contact',
            callback: function (contactId) {
                PJQ.app.session.project = null;
                PJQ.app.initNavigator({
                    activeItem: "contacts",
                    viewOptions: {
                        contactId: parseInt(contactId)
                    }
                });
            }
        },
        {
            route: 'contacts',
            name: 'contacts',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.module === PJQ.constants.modules.APP) {
                    if (PJQ.app.session.get('ownsPortal')) {
                        PJQ.app.initNavigator({
                            activeItem: "contacts"
                        });
                    }
                    else {
                        PJQ.app.initNavigator();
                    }
                }
                else {
                    PJQ.app.view.renderView(PJQ.views.addressbook.AddressBook);
                }
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.addressBook.routes);

PJQ.views.addressbook.AddressBookDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Results Available"
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        phoneWidth: '125px'
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeDataTableRender: function () {
        let self = this;
        this.options.rowCallback = function (row, data) {
            if (data.get('isBlacklisted') || (data.get('isCompanyBlacklisted') && data.get('contactCompanyId') === data.get('contactId'))) {
                $(row).find('td').css('text-decoration', 'line-through');
            }

            if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'addressBook')) {
                let abCustomization = PJQ.app.portal.customization.addressBook;
                if (typeof abCustomization.getRowColor === 'function') {
                    try {
                        let color = abCustomization.getRowColor(self.options.settings.view, data, {
                            companyCustomFields: PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')],
                            contactCustomFields: PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')]
                        });
                        if (_.size(color) > 0) {
                            $(row).css('background-color', color);
                        }
                    } catch {
                        //do nothing, we just dont want an error to happen due to code customizations
                    }
                }
            }
        };

        this.options.afterDataTableRender = _.bind(function () {
            this.$el.on('draw.dt', _.bind(function () {
                this.$el.find('div.pretty input.indeterminate').prop('indeterminate', true);
            }, this));
        }, this);

        this.options.childDataTables = [];

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        this.options.onRowDoubleClick = _.bind(function (row) {
            if (row.data() && row.data().get('contactId')) {
                this.editContact(row.data());
            }
        }, this);

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            if (this.options.settings.orderBy !== 'sortOrder') {
                if (_.size(this.options.settings.columns) === 0) {
                    this.options.settings.orderBy = this.options.settings.columnsDefault[0];
                } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                    this.options.settings.orderBy = this.options.settings.columns[0];
                }
            }
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy) {
                    this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
                }
            }, this));

            let fixedColumnsLeft = 0;
            switch (this.options.settings.view) {
                case PJQ.constants.addressBook.view.COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP:
                case PJQ.constants.addressBook.view.TRADES_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP:
                    fixedColumnsLeft = 1;
                    break;
                case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
                case PJQ.constants.addressBook.view.CONTACT_GROUP:
                    fixedColumnsLeft = 2;
                    break;
                case PJQ.constants.addressBook.view.CONTACT:
                case PJQ.constants.addressBook.view.COMPANY_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
                default:
                    break;
            }
            this.options.colReorder = {
                fixedColumnsLeft: fixedColumnsLeft,
                realtime: false
            };
        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }
            this.options.userSettings.set('settings', settings);
            this.options.userSettings.save();
        }
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {
    },
    orderByChanged: function() {
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('settings');
            for(let i = 0 ; i < _.size(settings) ; i++){
                if(settings[i].view === this.options.settings.view){
                    settings[i].orderBy = this.options.settings.orderBy;
                    settings[i].orderAscending = this.options.settings.orderAscending;
                }
            }
            this.options.userSettings.set('settings', settings);
            this.options.userSettings.save();
        }
    },
    editContact: function (model) {
        let fnFetch = _.bind(function (model, company) {
            let fnEdit = _.bind(function (model, company) {
                if (model.get('isApprovalRequired') && _.size(model.approvalUpdates.models) > 0) {
                    new PJQ.views.addressbook.ApproveAddressBookContactModal({
                        model: model,
                        onSave: _.bind(function (model) {
                            new PJQ.views.addressbook.EditCompanyModal({
                                model: model,
                                company: company,
                                contactId: model.get('contactCompanyId') > 0 ? model.id : null,
                                contactCompanyId: model.get('contactCompanyId'),
                                onSave: _.bind(function () {
                                    this.renderPage();
                                }, this),
                                onSaveContact: _.bind(function (contact, isNew) {
                                    if (isNew) {
                                        this.options.addressBookView.addSelectedContactsAll([contact.get('contactId')]);
                                        if (_.size(contact.get('contactGroups')) > 0) {
                                            this.options.addressBookView.addSelectedContactGroups(contact.get('contactGroups'));
                                        } else {
                                            this.options.addressBookView.addSelectedContactsNoGroup([contact.get('contactId')]);
                                        }
                                    }
                                }, this),
                                onDelete: _.bind(function () {
                                    this.renderPage();
                                }, this)
                            });
                        }, this)
                    })
                } else {
                    new PJQ.views.addressbook.EditCompanyModal({
                        model: model,
                        company: company,
                        contactId: model.get('contactCompanyId') > 0 ? model.id : null,
                        contactCompanyId: model.get('contactCompanyId'),
                        onSave: _.bind(function () {
                            this.renderPage();
                        }, this),
                        onSaveContact: _.bind(function (contact, isNew) {
                            if (isNew) {
                                this.options.addressBookView.addSelectedContactsAll([contact.get('contactId')]);
                                if (_.size(contact.get('contactGroups')) > 0) {
                                    this.options.addressBookView.addSelectedContactGroups(contact.get('contactGroups'));
                                } else {
                                    this.options.addressBookView.addSelectedContactsNoGroup([contact.get('contactId')]);
                                }
                            }
                        }, this),
                        onDelete: _.bind(function () {
                            this.renderPage();
                        }, this)
                    });
                }
            }, this);
            if (!model.isFetched) {
                model.fetch({
                    success: _.bind(function () {
                        fnEdit(model, company);
                    }, this)
                })
            } else {
                fnEdit(model, company);
            }
        }, this)

        if (!(model.get('contactCompanyId') > 0) || model.get('contactCompanyId') === model.id) {
            let company = new PJQ.models.contacts.Company({
                id: model.id
            });
            company.fetch({
                success: _.bind(function () {
                    fnFetch(_.find(company.contacts.models, function (model) {
                        return model.get('isPrimary')
                    }), company);
                }, this)
            })
        } else if (!(model instanceof PJQ.models.contacts.Contact)) {
            fnFetch(new PJQ.models.contacts.Contact(model));
        } else {
            fnFetch(model);
        }
    },
    statusChanged: function (statuses) {
    },
    getCustomFieldColumn: function (customField, isCompany) {
        return {
            "columnData": (isCompany ? 'companyCustomField' : 'contactCustomField') + '_' + customField.get('id'),
            "title": customField.get('fieldName'),
            "data": (isCompany ? 'CompanyFieldValue' : 'FieldValue') + customField.get('fieldNumber'),
            "render": function (data, type, row) {
                let rowField;
                if (isCompany) {
                    rowField = _.find(row.get('companyCustomFieldValues'), function (cf) {
                        return (cf.id === customField.get('id'));
                    });
                } else {
                    rowField = _.find(row.get('contactCustomFieldValues'), function (cf) {
                        return (cf.id === customField.get('id'));
                    });
                }

                let fieldValue = null;
                if (rowField != null) {
                    fieldValue = rowField.value;
                }
                // if(fieldValue == null && customField.get('defaultValue') !== "") {
                // 	fieldValue = customField.get('defaultValue');
                // 	if(!isNaN(parseInt(fieldValue))){
                // 		fieldValue = parseInt(fieldValue);
                // 	}
                // }
                switch (customField.get('fieldType')) {
                    case PJQ.constants.customFields.fieldTypes.TEXT:
                        if (fieldValue && type !== 'sort' && type !== 'type') {
                            if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                        }
                        break
                    case PJQ.constants.customFields.fieldTypes.DATE:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                        if (_.size(fieldValue) > 0) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.BOOL:
                        if (fieldValue != null)
                            fieldValue = fieldValue ? 'Yes' : 'No';
                        else
                            fieldValue = '';
                        break;
                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                        if (fieldValue) {
                            let choices = [];

                            // convert single choice value into array so that the logic below can work for both types.
                            if (typeof fieldValue === 'number')
                                fieldValue = [fieldValue];

                            _.each(customField.choices.models, _.bind(function (choice) {
                                if (_.find(fieldValue, function (value) {
                                    return value === choice.get('id');
                                }))
                                    choices.push(choice.get('choiceName'));
                            }, this));

                            fieldValue = choices.join((', '));

                            if (customField.get('fieldName').toLowerCase() === "approval level") {
                                let textColor;
                                if (fieldValue.toLowerCase() === 'green' || fieldValue.toLowerCase() === 'approved') {
                                    textColor = '#28a745'
                                }
                                if (fieldValue.toLowerCase() === 'yellow' || fieldValue.toLowerCase() === 'approved limited') {
                                    textColor = '#ffc107'
                                }
                                if (fieldValue.toLowerCase() === 'red' || fieldValue.toLowerCase() === 'not approved') {
                                    textColor = '#dc3545'
                                }
                                fieldValue = '<span style="color: ' + textColor + ';">' + fieldValue + '</span>';
                            }
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.PERCENT:
                        if (type !== 'sort' && type !== 'type') {
                            fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.MONEY:
                        if (type === 'sort' || type === 'type') {
                            if (fieldValue && fieldValue !== '$')
                                fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                            else
                                fieldValue = 0;

                        } else {
                            fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(fieldValue, 2) : '';
                        }
                        break;
                }
                return fieldValue;
            },
            "customFieldId": customField.get('id')
        };
    },
    childRowToggle: function (sender) {
        let $target = $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let childData = this.getRowChildData(row);
            if (childData != null) {
                let loader = new PJQ.Loader(this.$el.parent());
                childData.fetch({
                    type: 'POST',
                    data: {
                        searchFor: this.options.addressBookView.filter.searchFor,
                        locationFilter: this.options.addressBookView.filter.locationFilter,
                        zip: this.options.addressBookView.filter.zip,
                        radius: this.options.addressBookView.filter.radius,
                        directoryFilter: this.options.addressBookView.filter.directoryFilter,
                        userTypeFilter: this.options.addressBookView.filter.userTypeFilter,
                        groups: childData.options.groupId !== null ? [childData.options.groupId] : this.options.addressBookView.filter.groups,
                        groupDescription: childData.options.groupDescription,
                        page: 1,
                        pageSize: 2147483646,
                        isAdvancedSearch: this.options.addressBookView.isAdvancedSearch,
                        advancedSearch: this.options.addressBookView.advancedSearch,
                        contactCompanyId: childData.options.contactCompanyId,
                        contactId: childData.options.contactId,
                        isFilterApproved: this.options.addressBookView.filter.isFilterApproved,
                        isPrimaryOnly: this.options.addressBookView.filter.isPrimaryOnly,
                        isFilterUnapproved: this.options.addressBookView.filter.isFilterUnapproved,
                        proqualFilter: this.options.addressBookView.filter.proqualFilter,
                        isFilterActive: this.options.addressBookView.filter.isFilterActive,
                        isFilterInactive: this.options.addressBookView.filter.isFilterInactive,
                        isFilterUnion: this.options.addressBookView.filter.isFilterUnion,
                        isFilterNonUnion: this.options.addressBookView.filter.isFilterNonUnion,
                        isFilterPrevWage: this.options.addressBookView.filter.isFilterPrevWage,
                        isFilterNoLaborStatus: this.options.addressBookView.filter.isFilterNoLaborStatus,
                        isIncludeGroupList: this.options.addressBookView.settings.hasGroupListColumn(this.getChildTableType()),
                        includeScreeningPackages: this.options.addressBookView.settings.hasScreeningPackagesColumn(this.getChildTableType()),
                        includeContactCustomFields: this.options.addressBookView.settings.getContactCustomFieldColumns(this.getChildTableType()),
                        includeCompanyCustomFields: this.options.addressBookView.settings.getCompanyCustomFieldColumns(this.getChildTableType()),
                        isSelectionMode: !(this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
                    },
                    success: _.bind(function () {
                        loader.remove();
                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            parentId: id,
                            addressBookView: this.options.addressBookView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== id;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    /*
    childRowToggleAll: function (sender) {
        let $target = $(sender.currentTarget);

        this.dataTable.rows().eq(0).each(_.bind(function (index) {
            let row = this.dataTable.row(index), id = row.data().get('groupId');

            if ($target.hasClass('fa-plus-circle') && !row.child.isShown()) {
                let childClass = 'subgrid-' + id.toString(),
                    $childTable = $('<div data-id="' + id + '" />', {
                        class: childClass
                    });
                row.child($childTable).show();

                let childData = this.getRowChildData(row);
                if (childData != null) {
                    childData.fetch({
                        success: _.bind(function () {
                            let childTable = this.getRowChildTable({
                                el: $childTable,
                                data: childData.models,
                                parentDataTable: this,
                                parentId: id,
                                addressBookView: this.options.addressBookView
                            });
                            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                                return childDt.options.parentId !== id;
                            }, this));
                            this.options.childDataTables.push(childTable);
                            $(row.node()).addClass('shown');
                        }, this)
                    });
                }
            }
            else if ($target.hasClass('fa-minus-circle') && row.child.isShown()) {
                row.child.hide();
                $(row.node()).removeClass('shown');
            }

        }, this));

        if ($target.hasClass('fa-plus-circle'))
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        else
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
    },
     */
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    }
});

PJQ.views.addressbook.ContactDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .select-contact': 'contactSelectChanged',
        'click .select-all-contacts': 'contactSelectAllChanged',
        "click .btn-show-groups": "showRowGroups",
        'click .btn-copy-phone': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-fax': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-cell': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-email': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyEmail(e)
            }
        },
    },
    getContextMenuItems: function (a) {
        return [
            {
                name: PJQ.app.session.hasPermission('contacts.canEditContact') ? 'Edit Contact' : 'View Contact',
                iconClass: 'fal fa-user',
                onClick: _.bind(function (row) {
                    this.editContact(row.data());
                }, this)
            },
            {
                name: 'Add to Projects',
                iconClass: 'fal fa-plus-square',
                onClick: _.bind(function (row) {
                    this.addToProjects(row.data());
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('projects.isAdmin');
                }, this)
            },
            {
                name: 'Export Excel',
                iconClass: 'fal fa-file-excel',
                onClick: _.bind(function (row) {
                    row.data().exportExcel();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Approve Contact',
                iconClass: 'fal fa-thumbs-up',
                onClick: _.bind(function (row) {
                    let apprModel = row.data();
                    apprModel.approve(_.bind(function () {
                        if (typeof this.options.onApprove === 'function') {
                            this.options.onApprove(apprModel);
                        }
                        this.render();
                    }, this));
                }, this),
                isShown: _.bind(function (row) {
                    return row.data().get('isApprovalRequired') && PJQ.app.session.hasPermission('contacts.canApprove');
                }, this)
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId')
                    })
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Copy',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'copydirectorycontact'
                            },
                        ])
                    }).post().done(_.bind(function (data) {
                        this.render();
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: err.indexOf('Logic') === -1 ? err : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    row.data().getVcard();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Send Updater',
                iconClass: 'fal fa-poll-h',
                onClick: _.bind(function (row) {

                    let callback = function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact Updater Request sent'
                        });
                    };

                    new PJQ.views.modals.YesNo({
                        header: "Send Contact Updater",
                        body: "Are you sure you want to send this contact an Update Request?",
                        onYes: _.bind(function () {
                            row.data().sendUpdater(callback);
                        }, this)
                    });

                }, this)
            },
            {
                name: 'Request Prequal',
                iconClass: 'fal fa-file-invoice',
                onClick: _.bind(function (row) {

                    new PJQ.views.modals.YesNo({
                        header: "Send Prequalification Request",
                        body: "Are you sure you want to send this contact an Prequalification Request?",
                        onYes: _.bind(function () {
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'contacts',
                                        value: row.data().get('contactId')
                                    },
                                    {
                                        endpoint: 'prequal'
                                    },
                                    {
                                        endpoint: 'request'
                                    }
                                ])
                            }).post().done(_.bind(function (data) {
                                if (data && data.success) {
                                    PJQ.notifications.notify.successNotify({
                                        message: 'Qualification update sent'
                                    });
                                    $('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
                                } else {
                                    PJQ.notifications.notify.errorNotify({
                                        message: 'Qualification update failed, invalid email address on contact'
                                    });
                                }
                            }, this)).fail(function (xhr, err, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                                    error: err,
                                    result: result
                                });
                            });

                        }, this)
                    });

                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.subscription.hasFeature('projectmessaging') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL)
                }, this)
            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    row.data().showProjectHistory();
                }, this),
            },
            {
                name: 'Delete Contact',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Contact",
                        body: "Are you sure you want to delete this contact from the address book?",
                        onDelete: _.bind(function () {
                            row.data().destroy({
                                success: () => {
                                    // hide children
                                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                                        if (row.child.isShown())
                                            row.child.hide();
                                    }
                                    let parentTR = this.options.parentDataTable ? $(row.node()).parent().closest('tr').prev() : null,
                                        parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

                                    row.remove().draw(false);

                                    if (this.options.parentDataTable && this.options.addressBookView.currentView !== PJQ.constants.addressBook.view.TRADES_CONTACT) {
                                        if (parentRow.data().get('contactCount') === 1)
                                            parentRow.remove().draw(false);
                                    }
                                }
                            });
                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
                }, this)
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'contactName', 'title', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'cell', 'fax', 'email', 'contactId', 'contactCompanyId', 'isAutoSelectDisabled', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'gradeAverage', 'userType', 'activityRank', 'prequalPercent'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
            includeColumns.push('screeningPackages');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (this.options.isShowCheckboxes) {
            columns.push({
                "columnData": '',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(this.renderContactSelect, this)
            });
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.addressBookView && this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                columns.push({
                    "columnData": "contactGroups",
                    "data": null,
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle expand-item contact-toggle-row" data-type="contactId" data-id="' + row.get('contactId') + '"></i>';
                    }
                });
            }
        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '80px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];
                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<i class='fas fa-user-clock fs-18 mr-1' title='Qualification Pending'></i>");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-edit fs-18 mr-1' title='Qualification In Process'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-search fs-18 mr-1' title='Qualification Needs Review'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-check fs-18 mr-1' title='All Enrolled'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-clipboard-list-check fs-18 mr-1' title='Qualification Feedback Required'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<i class='fas fa-file-exclamation fs-18 mr-1' title='Qualification Expired'></i>");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('masterUserId') === 39 && PJQ.app.options.isPanteraApp)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");


                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18 mr-1' title='Prequalification Available'></i>");
                            }

                            if (row.get('isApprovalRequired')) {
                                icons.push("<i class='fas fa-exclamation-circle text-gold fs-18 mr-1' title='Awaiting Approval'></i>");
                            }

                            if (row.get('updatedOn') != null) {
                                icons.push("<i class='fas fa-check-circle text-success fs-18 mr-1' title='Updated by Contact at " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('updatedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            }

                            if (row.get('isPrimary')) {
                                icons.push("<i class='fal fa-crown fs-18' title='Primary Contact'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'contactCompanyId':
                    columns.push({
                        "columnData": "contactCompanyId",
                        "data": "attributes.contactCompanyId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) : "Company ID",
                    });
                    break;
                case 'contactId':
                    columns.push({
                        "columnData": "contactId",
                        "data": "attributes.contactId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_ID_LABEL) : "Contact ID",
                    });
                    break;
                case 'isAutoSelectDisabled':
                    columns.push({
                        "columnData": "isAutoSelectDisabled",
                        "data": "attributes.isAutoSelectDisabled",
                        "title": "Selection Status",
                        "render": _.bind(function (data, type, row) {
                            return data ? 'Off' : 'On'
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State",
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip",
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country",
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Labor Status',
                        "data": 'unionStatus',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "data": 'sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "data": 'certifications',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupArray = data.split(',')
                            if (_.size(groupArray) > 5) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - 5).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - 5) + " more item(s)</a>"
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'gradeAverage':
                    columns.push({
                        "columnData": 'gradeAverage',
                        "title": 'Grade',
                        "data": 'grade',
                        "render": function (data, type, row) {
                            return row.get('gradeAverage').toFixed(1);
                        }
                    });
                    break;
                case 'userType':
                    columns.push({
                        "columnData": 'userType',
                        "title": 'Contact Type',
                        "data": 'userType',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'activityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'activityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Activity'
                        });
                    }
                    break;
                case 'prequalPercent':
                    columns.push({
                        "columnData": "prequalPercent",
                        "data": "attributes.prequalPercent",
                        "title": "Prequal Percent",
                        "render": function (data, type, row) {
                            if (data < 60) {
                                return '<span class="text-danger">' + data + '</span>'
                            } else if (data === 100) {
                                return '<span class="text-success">' + data + '</span>'
                            } else if (data >= 60) {
                                return '<span class="text-warning">' + data + '</span>'
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'screeningPackages':
                    columns.push({
                        "columnData": "screeningPackages",
                        "data": "attributes.screeningPackages",
                        "title": "Qualification Packages",
                        "render": _.bind(function (data, type, row) {
                            let ct = _.size(data);
                            if (ct > 0) {
                                let packageNames = [];
                                _.each(this.options.addressBookView.screeningSettings.get('packages'), function (pkg) {
                                    if (data.indexOf(pkg.screeningPackageId) !== -1) {
                                        packageNames.push(pkg.packageName);
                                    }
                                });
                                return '<div>' + packageNames.join(', ') + '</div>'
                            }
                            return 'None';
                        }, this)
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    addToProjects: async function (contact) {
        let projects = await contact.getContactProjects();

        new PJQ.views.projects.ProjectSelectorModal({
            excludeProjectIds: _.map(projects, function (project) {
                return project.id;
            }),
            isSingleChoice: false,
            onSave: _.bind(async function (newProjects) {
                let projectIds = _.map(newProjects, function (project) {
                    return project.id;
                });

                try{
                    await contact.addToProjects(projectIds);
                    PJQ.notifications.notify.successNotify({
                        message: `Contact successfully added to ${_.size(projectIds)} projects`
                    });
                }
                catch{
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error adding contact to projects'
                    });
                }
            }, this)
        });
    },
    getChildTableType: function () {
        return PJQ.constants.addressBook.view.CONTACT_GROUP;
    },
    getChildTableSettings: function () {
        return null; //this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.order = [];
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = true;
        childOpts.paging = false;
        return new PJQ.views.addressbook.ContactGroupDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: PJQ.constants.addressBook.view.CONTACT_GROUP,
            contactId: row.data().get('contactId'),
            groupId: row.data().collection.options.groupId
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-contact.indeterminate').prop('indeterminate', true);
    },
    isContactSelected: function (row) {
        let selected = (this.options.addressBookView.options.disabledContacts.indexOf(row.contactId) !== -1);

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            if (_.size(row.contactGroups) > 0) {
                selected = selected || _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)) > 0 ||
                    _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups)) > 0;
            } else {
                selected = selected || (this.options.addressBookView.selectedContactsNoGroup.indexOf(row.contactId) !== -1);
            }
        } else
            selected = selected || (this.options.addressBookView.selectedContactsAll.indexOf(row.contactId) !== -1);

        return selected;
    },
    isContactIndeterminate: function (row) {
        let indeterminate = false,
            contactGroups = _.size(row.contactGroups),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            if (contactGroups > 0 && (disabledGroups + selectedGroups > 0)) {
                indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups);
            }
        }

        return indeterminate;
    },
    isContactDisabled: function (row) {
        let disabled = (row.isBlacklisted === true && this.options.addressBookView.options.selectionMode !== PJQ.constants.addressBook.selectionMode.MERGE) || (this.options.addressBookView.options.disabledContacts.indexOf(row.contactId) !== -1);
        if (_.size(row.contactGroups) > 0) {
            disabled = disabled || _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)) === _.size(row.contactGroups);
        }

        return disabled;
    },
    renderContactSelect: function (data, type, row) {
        let isSelected = this.isContactSelected(row.attributes),
            isIndeterminate = this.isContactIndeterminate(row.attributes),
            isDisabled = this.isContactDisabled(row.attributes);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth' + (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT ? ' p-has-indeterminate' : '') + ' fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected && !isIndeterminate ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-contact' + (isIndeterminate ? ' indeterminate ' : '') + '" />';

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            html += '<div class="state"><i class="icon far fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
                '<div class="state p-is-indeterminate"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>';
        } else {
            html += '<div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>';
        }

        html += '</div></div>';

        return (html);
    },
    updateContactSelect: function (row) {
        let isSelected = this.isContactSelected(row.data().attributes),
            isIndeterminate = this.isContactIndeterminate(row.data().attributes),
            isDisabled = this.isContactDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');

        if (isIndeterminate)
            $cb.prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        else if (isSelected)
            $cb.prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        else
            $cb.prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
    },
    contactSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsAll([row.data().get('contactId')]);

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                if (_.size(row.data().get('contactGroups')) > 0)
                    this.options.addressBookView.addSelectedContactGroups(row.data().get('contactGroups'));
                else
                    this.options.addressBookView.addSelectedContactsNoGroup([row.data().get('contactId')]);
            }
        } else {
            this.options.addressBookView.removeSelectedContactsAll([row.data().get('contactId')]);

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                if (_.size(row.data().get('contactGroups')) > 0)
                    this.options.addressBookView.removeSelectedContactGroups(row.data().get('contactGroups'));
                else
                    this.options.addressBookView.removeSelectedContactsNoGroup([row.data().get('contactId')]);
            }
        }

        this.updateContactSelect(row);

        // cascade up to parents
        if (this.options.parentDataTable && parentRow) {
            if ([PJQ.constants.addressBook.view.COMPANY, PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY].indexOf(this.options.parentDataTable.options.view) !== -1) {
                this.options.parentDataTable.updateCompanySelect(parentRow);
            }
        }

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
            [PJQ.constants.addressBook.view.CONTACT, PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.view) !== -1) {
            _.each(this.options.childDataTables, _.bind(function (childDT) {
                if (childDT.options.parentId === row.data().get('contactId')) {
                    _.each(childDT.$el.find('.select-contactgroup'), _.bind(function (input) {
                        childDT.updateContactGroupSelect(childDT.getRow($(input).closest('tr')));
                    }, this));
                }
            }, this));
        }

    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(',')
        target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
    },
    contactSelectAllChanged: function (e) {
        let parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            callback = _.bind(function () {
                _.each(this.$el.find('.select-contact'), _.bind(function (input) {
                    this.updateContactSelect(this.getRow($(input).closest('tr')));
                }, this));

                if (this.options.parentDataTable && [PJQ.constants.addressBook.view.COMPANY, PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY].indexOf(this.options.parentDataTable.options.view) !== -1) {
                    this.options.parentDataTable.updateCompanySelect(parentRow);
                }

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                    [PJQ.constants.addressBook.view.CONTACT, PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.view) !== -1) {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        _.each(childDT.$el.find('.select-contactgroup'), _.bind(function (input) {
                            childDT.updateContactGroupSelect(childDT.getRow($(input).closest('tr')));
                        }, this));
                    }, this));
                }
            }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // loop through our data, add everyone, and update the checkboxes.
            let contacts = [],
                contactGroups = [],
                contactsNoGroup = [];

            _.each(this.$el.find('.select-contact'), _.bind(function (input) {
                let row = this.getRow($(input).closest('tr'));
                if (!row.data().get('isAutoSelectDisabled')) {
                    contacts.push(row.data().get('contactId'));
                    $.merge(contactGroups, row.data().get('contactGroups'));
                    if (_.size(row.data().get('contactGroups')) === 0)
                        contactsNoGroup.push(row.data().get('contactId'));
                }
            }, this));

            if ($(e.currentTarget).prop('checked')) {
                this.options.addressBookView.addSelectedContactsAll(contacts);

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.addSelectedContactGroups(contactGroups);
                    this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup)
                }
            } else {
                this.options.addressBookView.removeSelectedContactsAll(contacts);

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.removeSelectedContactGroups(contactGroups);
                    this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup)
                }
            }

            callback();
        }

    }
});

PJQ.views.addressbook.CompanyDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.company-toggle-row': 'childRowToggle',
        'click .select-company': 'companySelectChanged',
        'click .select-all-companies': 'companySelectAllChanged',
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail',
        "click .btn-show-groups": "showRowGroups"
    },
    getContextMenuItems: function () {
        return [
            {
                name: PJQ.app.session.hasPermission('contacts.canEditContact') ? 'Edit Contact' : 'View Contact',
                iconClass: 'fal fa-user',
                onClick: _.bind(function (row) {
                    this.editContact(row.data());
                }, this)
            },
            {
                name: 'Export Excel',
                iconClass: 'fal fa-file-excel',
                onClick: _.bind(function (row) {
                    row.data().exportExcel();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    let contact = new PJQ.models.contacts.Contact(row.data());
                    contact.getVcard();
                }, this),
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId')
                    })
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Copy',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'copydirectorycontact'
                            },
                        ])
                    }).post().done(_.bind(function (data) {
                        this.render();
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: err.indexOf('Logic') === -1 ? err : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Delete Company',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Company",
                        body: "Are you sure you want to delete this company from the address book?  NOTE: All contacts in this company will also be deleted, including ones that may not be visible due to filters.",
                        onDelete: _.bind(function () {
                            let contact = new PJQ.models.contacts.Company(row.data().attributes);
                            contact.destroy();

                            if (row.child.isShown())
                                row.child.hide();

                            row.remove().draw(false);
                            this.dataTable.rows().invalidate().draw(false);

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
                }, this)
            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    let contact = new PJQ.models.contacts.Contact(row.data().attributes);
                    contact.showProjectHistory();
                }, this),
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'primaryContactName', 'primaryContactTitle', 'primaryContactUserType', 'primaryAddress1', 'primaryAddress2', 'primaryCity', 'primaryState', 'primaryZip', 'primaryCountry', 'primaryPhone', 'primaryCell', 'primaryFax', 'primaryEmail', 'contactCompanyId', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'gradeAverage', 'primaryActivityRank', 'companyActivityRank', 'contactCount', 'prequalPercent'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
            includeColumns.push('screeningPackages');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.isShowCheckboxes) {
                columns.push({
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-companies" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderCompanySelect, this)
                });
            }

            columns.push({
                "columnData": "companyContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "width": "40px",
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle expand-item company-toggle-row" data-type="contactCompanyId" data-id="' + row.get('contactCompanyId') + '"></i>';
                }
            });

        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];
                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<i class='fas fa-user-clock fs-18 mr-1' title='Qualification Pending'></i>");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-edit fs-18 mr-1' title='Qualification In Process'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-search fs-18 mr-1' title='Qualification Needs Review'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-check fs-18 mr-1' title='All Enrolled'></i>");
                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-clipboard-list-check fs-18 mr-1' title='Qualification Feedback Required'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<i class='fas fa-file-exclamation fs-18 mr-1' title='Qualification Expired'></i>");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('masterUserId') === 39 && PJQ.app.options.isPanteraApp)
                                    icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18' title='Prequalification Available'></i>");
                            }


                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'primaryContactName':
                    columns.push({
                        "columnData": "primaryContactName",
                        "data": "attributes.contactName",
                        "title": "Primary Contact",
                    });
                    break;
                case 'primaryTitle':
                    columns.push({
                        "columnData": "primaryTitle",
                        "data": "attributes.title",
                        "title": "Primary Title"
                    });
                    break;
                case 'primaryContactUserType':
                    columns.push({
                        "columnData": "primaryContactUserType",
                        "data": "attributes.defaultContactUserTypeId",
                        "title": "Primary User Type",
                        "render": _.bind(function (data, type, row) {
                            let userType = PJQ.app.session.userTypes.get(data);
                            if(userType){
                                return '<span style="color: ' + userType.get('color') +' !important;">' + userType.get('name') + '</span>';
                            }
                        }, this)
                    });
                    break;
                case 'primaryAddress1':
                    columns.push({
                        "columnData": "primaryAddress1",
                        "data": "attributes.address1",
                        "title": "Primary Address 1"
                    });
                    break;
                case 'primaryAddress2':
                    columns.push({
                        "columnData": "primaryAddress2",
                        "data": "attributes.address2",
                        "title": "Primary Address 2"
                    });
                    break;
                case 'primaryCity':
                    columns.push({
                        "columnData": "primaryCity",
                        "data": "attributes.city",
                        "title": "Primary City"
                    });
                    break;
                case 'primaryState':
                    columns.push({
                        "columnData": "primaryState",
                        "data": "attributes.state",
                        "title": "Primary State",
                        "width": "100px",
                    });
                    break;
                case 'primaryZip':
                    columns.push({
                        "columnData": "primaryZip",
                        "data": "attributes.zip",
                        "title": "Primary Zip",
                    });
                    break;
                case 'primaryCountry':
                    columns.push({
                        "columnData": "primaryCountry",
                        "data": "attributes.country",
                        "title": "Primary Country",
                    });
                    break;
                case 'primaryPhone':
                    columns.push({
                        "columnData": "primaryPhone",
                        "data": "attributes.phone",
                        "title": "Primary Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryCell':
                    columns.push({
                        "columnData": "primaryCell",
                        "data": "attributes.cell",
                        "title": "Primary Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryFax':
                    columns.push({
                        "columnData": "primaryFax",
                        "data": "attributes.fax",
                        "title": "Primary Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryEmail':
                    columns.push({
                        "columnData": "primaryEmail",
                        "data": "attributes.email",
                        "title": "Primary Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'contactCompanyId':
                    columns.push({
                        "columnData": "contactCompanyId",
                        "data": "attributes.contactCompanyId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) : "Company ID",
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "data": "unionStatus",
                        "title": 'Labor Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "data": "sector",
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "data": "certifications",
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupArray = data.split(',')
                            if (_.size(groupArray) > 5) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - 5).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - 5) + " more item(s)</a>"
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'gradeAverage':
                    columns.push({
                        "columnData": 'gradeAverage',
                        "title": 'Grade',
                        "data": "grade",
                        "render": function (data, type, row) {
                            return row.get('gradeAverage').toFixed(1);
                        }
                    });
                    break;
                case 'primaryActivityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'primaryActivityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Primary Activity'
                        });
                    }
                    break;
                case 'companyActivityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'companyActivityRank',
                            "data": 'attributes.companyActivityRank',
                            "title": 'Company Activity'
                        });
                    }
                    break;
                case 'contactCount':
                    columns.push({
                        "columnData": "contactCount",
                        "data": "attributes.contactCount",
                        "title": "Contacts",
                    });
                    break;
                case 'prequalPercent':
                    columns.push({
                        "columnData": "prequalPercent",
                        "data": "attributes.prequalPercent",
                        "title": "Prequal Percent",
                        "render": function (data, type, row) {
                            if (data < 60) {
                                return '<span class="text-danger">' + data + '</span>'
                            } else if (data === 100) {
                                return '<span class="text-success">' + data + '</span>'
                            } else if (data >= 60) {
                                return '<span class="text-warning">' + data + '</span>'
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'screeningPackages':
                    columns.push({
                        "columnData": "screeningPackages",
                        "data": "attributes.screeningPackages",
                        "title": "Qualification Packages",
                        "render": _.bind(function (data, type, row) {
                            let ct = _.size(data);
                            if (ct > 0) {
                                let packageNames = [];
                                _.each(this.options.addressBookView.screeningSettings.get('packages'), function (pkg) {
                                    if (data.indexOf(pkg.screeningPackageId) !== -1) {
                                        packageNames.push(pkg.packageName);
                                    }
                                });
                                return '<div>' + packageNames.join(', ') + '</div>'
                            }
                            return 'None';
                        }, this)
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = this.options.addressBookView.isShowCheckboxes;
        return new PJQ.views.addressbook.ContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: 'contact',
            contactCompanyId: row.data().get('contactCompanyId'),
            groupId: row.data().collection.options.groupId
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-company.indeterminate').prop('indeterminate', 'true');
    },
    isCompanySelected: function (row) {
        let selected = false,
            disabledContactsNoGroup = _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts)),
            selectedContactsNoGroup = _.size(_.intersection(this.options.addressBookView.selectedContactsNoGroup, row.noGroupContacts)),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            selected = selected || ((disabledContactsNoGroup + selectedContactsNoGroup + disabledGroups + selectedGroups) > 0);
        } else
            selected = selected || (_.size(_.intersection(this.options.addressBookView.selectedContactsAll, row.selectableContacts)) > 0);

        return selected;
    },
    isCompanyIndeterminate: function (row) {
        let indeterminate = false,
            isSelected = this.isCompanySelected(row),
            selectableContacts = _.size(row.selectableContacts),
            selectedContacts = _.size(_.intersection(this.options.addressBookView.selectedContactsAll, row.selectableContacts)),
            contactsNoGroup = _.size(row.noGroupContacts),
            disabledContactsNoGroup = _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts)),
            selectedContactsNoGroup = _.size(_.intersection(this.options.addressBookView.selectedContactsNoGroup, row.noGroupContacts)),
            contactGroups = _.size(row.contactGroups),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (isSelected) {
            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {

                if (contactsNoGroup === 0 && contactGroups > 0) {
                    indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups);
                } else if (contactsNoGroup > 0 && contactGroups === 0) {
                    indeterminate = indeterminate || (contactsNoGroup > disabledContactsNoGroup + selectedContactsNoGroup);
                } else if (contactsNoGroup > 0 && contactGroups > 0) {
                    indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups) || (contactsNoGroup > disabledContactsNoGroup + selectedContactsNoGroup);
                }
            } else {
                indeterminate = indeterminate || (selectedContacts > 0 && (selectableContacts > selectedContacts));
            }
        }

        return indeterminate;
    },
    isCompanyDisabled: function (row) {
        let disabled = false;
        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {

            let allNoGroupContactsDisabled = _.size(row.noGroupContacts) === 0 || (_.size(row.noGroupContacts) === _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts))),
                allContactGroupsDisabled = _.size(row.contactGroups) === 0 || (_.size(row.contactGroups) === _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)));

            disabled = allContactGroupsDisabled && allNoGroupContactsDisabled;

        } else {
            disabled = (_.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.selectableContacts)) === _.size(row.selectableContacts));
        }

        return disabled;
    },
    renderCompanySelect: function (data, type, row) {
        let isSelected = this.isCompanySelected(row.attributes),
            isIndeterminate = this.isCompanyIndeterminate(row.attributes),
            isDisabled = this.isCompanyDisabled(row.attributes);

        return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth p-has-indeterminate fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected && !isIndeterminate ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-company' + (isIndeterminate ? ' indeterminate ' : '') + '" />' +
            '<div class="state"><i class="icon far fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '<div class="state p-is-indeterminate"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '</div></div>');
    },
    updateCompanySelect: function (row) {
        let selectedCompanyContacts = _.intersection(this.options.addressBookView.selectedContactsAll, row.data().get('selectableContacts')),
            isSelected = this.isCompanySelected(row.data().attributes),
            isIndeterminate = this.isCompanyIndeterminate(row.data().attributes),
            isDisabled = this.isCompanyDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');
        if (isIndeterminate)
            $cb.prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        else if (isSelected)
            $cb.prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        else
            $cb.prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
    },
    companySelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);
        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsAll(row.data().get('selectableContacts'));

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                this.options.addressBookView.addSelectedContactsNoGroup(row.data().get('noGroupContacts'));
                this.options.addressBookView.addSelectedContactGroups(row.data().get('contactGroups'));
            }
        } else {
            this.options.addressBookView.removeSelectedContactsAll(row.data().get('selectableContacts'));
            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                this.options.addressBookView.removeSelectedContactsNoGroup(row.data().get('noGroupContacts'));
                this.options.addressBookView.removeSelectedContactGroups(row.data().get('contactGroups'));
            }
        }

        this.updateCompanySelect(row);

        // todo: cascade down to contacts / etc
        _.each(this.options.childDataTables, _.bind(function (childDT) {
            if (childDT.options.parentId === row.data().get('contactId')) {
                _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                    childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));

                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                        this.options.view === PJQ.constants.addressBook.view.COMPANY) {
                        _.each(childDT.options.childDataTables, _.bind(function (childDTchild) {
                            _.each(childDTchild.$el.find('.select-contactgroup'), _.bind(function (input) {
                                childDTchild.updateContactGroupSelect(childDTchild.getRow($(input).closest('tr')));
                            }, this));
                        }, this));
                    }
                }, this));
            }
        }, this));
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(',')
        target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
    },
    companySelectAllChanged: function (e) {
        let callback = _.bind(function () {
            _.each(this.$el.find('.select-company'), _.bind(function (input) {
                this.updateCompanySelect(this.getRow($(input).closest('tr')));
            }, this));

            _.each(this.options.childDataTables, _.bind(function (childDT) {
                _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                    childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));

                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                        this.options.view === PJQ.constants.addressBook.view.COMPANY) {
                        _.each(childDT.options.childDataTables, _.bind(function (childDTchild) {
                            _.each(childDTchild.$el.find('.select-contactgroup'), _.bind(function (input) {
                                childDTchild.updateContactGroupSelect(childDTchild.getRow($(input).closest('tr')));
                            }, this));
                        }, this));
                    }
                }, this));
            }, this));
        }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // loop through our data, add everyone, and update the checkboxes.
            let contacts = [], contactsNoGroup = [], contactGroups = [];
            _.each(this.$el.find('.select-company'), _.bind(function (input) {
                let row = this.getRow($(input).closest('tr'));
                $.merge(contacts, row.data().get('selectableContacts'));
                $.merge(contactsNoGroup, row.data().get('noGroupContacts'));
                $.merge(contactGroups, row.data().get('contactGroups'));
            }, this));
            if ($(e.currentTarget).prop('checked')) {
                this.options.addressBookView.addSelectedContactsAll(contacts);
                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup);
                    this.options.addressBookView.addSelectedContactGroups(contactGroups);
                }
            } else {
                this.options.addressBookView.removeSelectedContactsAll(contacts);
                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup);
                    this.options.addressBookView.removeSelectedContactGroups(contactGroups);
                }
            }

            callback();
        }
    }
});

PJQ.views.addressbook.GroupHeaderDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.group-toggle-row': 'childRowToggle',
        'click .select-all-trades': 'tradeSelectAllChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['groupDescription', 'groupName', 'groupCount', 'childCount'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "columnData": "groupChildren",
                "data": null,
                "title": this.options.isShowCheckboxes ? '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="' + (this.options.parentDataTable ? 'select-all-trades-division' : 'select-all-trades') + '" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>' : '',
                "orderable": false,
                "searchable": false,
                "width": "40px",
                "defaultContent": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    if (this.options.settings.showGroupDescription)
                        html = '<i class="fal fa-plus-circle expand-item group-toggle-row" data-type="groupDescription" data-id="' + row.get('groupDescription') + '"></i>';
                    else
                        html = '<i class="fal fa-plus-circle expand-item group-toggle-row" data-type="groupId" data-id="' + row.get('groupId') + '"></i>';

                    return html;
                }, this)
            });

            columns.push({
                "columnData": "sortOrder",
                "data": "attributes.sortOrder",
                "searchable": false,
                "defaultContent": '',
                "visible": false
            });

        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": "attributes.groupName",
                        "width": "40%",
                        "title": "Trade",
                    });
                    break;
                case 'groupDescription':
                    columns.push({
                        "columnData": "groupDescription",
                        "data": "attributes.groupDescription",
                        "width": "40%",
                        "title": "Division",
                    });
                    break;
                case 'childCount':
                    columns.push({
                        "columnData": "childCount",
                        "data": "attributes.childCount",
                        "title": (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? "Companies" : "Contacts"
                    });
                    break;
                case 'groupCount':
                    columns.push({
                        "columnData": "groupCount",
                        "data": "attributes.groupCount",
                        "width": "150px",
                        "title": "Trades"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        let view = '';
        if (this.options.settings.showGroupDescription)
            view = this.options.view + '-group';
        else {
            switch (this.options.view) {
                case PJQ.constants.addressBook.view.TRADES_COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP:
                    view = PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY;
                    break;
                case PJQ.constants.addressBook.view.TRADES_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP:
                    view = PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT;
                    break;
            }
        }
        return view;
    },
    getChildTableSettings: function () {
        return this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = this.options.addressBookView.isShowCheckboxes;

        let result = null;
        if (this.options.settings.showGroupDescription)
            result = new PJQ.views.addressbook.GroupHeaderChildDataTable(childOpts);
        else
            result = (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? new PJQ.views.addressbook.CompanyDataTable(childOpts) : new PJQ.views.addressbook.ContactDataTable(childOpts);

        return result;
    },
    getRowChildData: function (row) {
        let view = (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? "company" : "contact";
        if (this.options.settings.showGroupDescription)
            view = this.options.view;

        let viewOptions = {
            view: view,
            groupId: this.options.settings.showGroupDescription ? null : row.data().get('groupId'),
            groupDescription: this.options.settings.showGroupDescription && row.data() ? row.data().get('groupDescription') : null
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    tradeSelectAllChanged: function (e) {
        let processViews = _.bind(function (childDT) {
                if (childDT.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY) {

                    _.each(childDT.$el.find('.select-company'), _.bind(function (input) {
                        childDT.updateCompanySelect(childDT.getRow($(input).closest('tr')));
                    }, this));

                    _.each(childDT.options.childDataTables, _.bind(function (contactDT) {
                        _.each(contactDT.$el.find('.select-contact'), _.bind(function (input) {
                            contactDT.updateContactSelect(contactDT.getRow($(input).closest('tr')));
                        }, this));
                    }, this));
                } else {
                    _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                        childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));
                    }, this));
                }
            }, this),
            callback = _.bind(function () {
                if (this.options.settings.showGroupDescription) {
                    _.each(this.options.childDataTables, _.bind(function (tradeDT) {
                        _.each(tradeDT.options.childDataTables, _.bind(function (childDT) {
                            processViews(childDT);
                        }, this));
                    }, this));
                } else {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        processViews(childDT);
                    }, this));
                }
            }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // showGroupDescription is ON, so we must figure out only the contacts with this groupDescription.
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), this.options.parentId, _.bind(function () {
                callback();
            }, this));
        }
    }
});

PJQ.views.addressbook.GroupHeaderChildDataTable = PJQ.views.addressbook.GroupHeaderDataTable.extend({
    events: {
        'click i.group-toggle-row': 'childRowToggle',
        'click .select-all-trades-division': 'tradeSelectAllChanged'
    }
});

PJQ.views.addressbook.ContactGroupDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click .select-all-contactgroup': 'contactGroupSelectAllChanged',
        'click .select-contactgroup': 'contactGroupSelectChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['groupName'];

        if (!includeAllColumns) {
            columns.push({
                "columnData": '',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contactgroup" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(this.renderContactGroupSelect, this)
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": "attributes.groupName",
                        "title": "Trade",
                        "orderable": false
                    });
                    break;
            }
        }, this));

        return columns;
    },
    isContactGroupSelected: function (row) {
        let selected = (this.options.addressBookView.options.disabledContactGroups && this.options.addressBookView.options.disabledContactGroups.indexOf(row.contactGroupId) !== -1) ||
            (this.options.addressBookView.options.disabledContacts.indexOf(this.options.parentId) !== -1 && row.contactGroupId === 0) ||
            (this.options.addressBookView.selectedContactGroups.indexOf(row.contactGroupId) !== -1) ||
            (this.options.addressBookView.selectedContactsNoGroup.indexOf(this.options.parentId) !== -1);

        return selected;
    },
    isContactGroupDisabled: function (row) {
        let disabled = (this.options.addressBookView.options.disabledContacts.indexOf(this.options.parentId) !== -1 && row.contactGroupId === 0) ||
            (this.options.addressBookView.options.disabledContactGroups && this.options.addressBookView.options.disabledContactGroups.indexOf(row.contactGroupId) !== -1);
        return disabled;
    },
    renderContactGroupSelect: function (data, type, row) {
        let isSelected = this.isContactGroupSelected(row.attributes),
            isDisabled = this.isContactGroupDisabled(row.attributes);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + ' class="select-contactgroup" />' +
            '<div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '</div></div>';

        return (html);
    },
    updateContactGroupSelect: function (row) {
        let isSelected = this.isContactGroupSelected(row.data().attributes),
            isDisabled = this.isContactGroupDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');

        $cb.prop('checked', isSelected);
    },
    contactGroupSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentParentTR = parentTR.parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            parentParentRow = this.options.parentDataTable && this.options.parentDataTable.options.parentDataTable ? this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR) : null;

        if ($(e.currentTarget).prop('checked')) {

            if (row.data().get('contactGroupId') > 0)
                this.options.addressBookView.addSelectedContactGroups([row.data().get('contactGroupId')]);
            else
                this.options.addressBookView.addSelectedContactsNoGroup([this.options.parentId]);
        } else {
            if (row.data().get('contactGroupId') > 0)
                this.options.addressBookView.removeSelectedContactGroups([row.data().get('contactGroupId')]);
            else
                this.options.addressBookView.removeSelectedContactsNoGroup([this.options.parentId]);
        }

        // cascade up to parents
        if (this.options.parentDataTable && parentRow) {
            this.options.parentDataTable.updateContactSelect(parentRow);
            if ([PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.parentDataTable.options.view) !== -1) {
                // find company view that owns the contact view, and update THAT
                this.options.parentDataTable.options.parentDataTable.updateCompanySelect(parentParentRow);
            }
        }
    },
    contactGroupSelectAllChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentParentTR = parentTR.parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            parentParentRow = this.options.parentDataTable && this.options.parentDataTable.options.parentDataTable ? this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR) : null,
            contactsNoGroup = [],
            contactGroups = [];

        // loop through our data, add everyone, and update the checkboxes.
        _.each(this.$el.find('.select-contactgroup'), _.bind(function (input) {
            let row = this.getRow($(input).closest('tr'));
            if (row.data().get('contactGroupId') === 0)
                contactsNoGroup.push(this.options.parentId);
            else
                contactGroups.push(row.data().get('contactGroupId'));
        }, this));

        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup);
            this.options.addressBookView.addSelectedContactGroups(contactGroups);
        } else {
            this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup);
            this.options.addressBookView.removeSelectedContactGroups(contactGroups);
        }

        _.each(this.$el.find('.select-contactgroup'), _.bind(function (input) {
            this.updateContactGroupSelect(this.getRow($(input).closest('tr')));
        }, this));

        if (this.options.parentDataTable && parentRow) {
            this.options.parentDataTable.updateContactSelect(parentRow);
            if ([PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.parentDataTable.options.view) !== -1) {
                // find company view that owns the contact view, and update THAT
                this.options.parentDataTable.options.parentDataTable.updateCompanySelect(parentParentRow);
            }
        }
    }
});

PJQ.models.addressBook = {};

PJQ.models.addressBook.AddressBookViewSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		let params = [];
		if (this.options.forCompany) {
			params.push({
				parameter: 'forCompany',
				value: true
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'settings'
			}
		], params);
	},
	getSettings: function (view) {
		return _.find(this.attributes.settings, _.bind(function (setting) {
			return setting.view === view;
		}, this));
	},
	hasGroupListColumn: function (view) {
		let setting = this.getSettings(view), columnFound = false;
		_.each(setting.columns, _.bind(function (column) {
			if (column === 'groupListDisplay') {
				columnFound = true;
			}
		}, this));
		return columnFound;
	},
	hasScreeningPackagesColumn: function (view) {
		let setting = this.getSettings(view), columnFound = false;
		_.each(setting.columns, _.bind(function (column) {
			if (column === 'screeningPackages') {
				columnFound = true;
			}
		}, this));
		return columnFound;
	},
	getContactCustomFieldColumns: function (view) {
		let setting = this.getSettings(view), columns = [];
		_.each(setting.columns, _.bind(function (column) {
			if (column.startsWith('contactCustomField_')) {
				columns.push(parseInt(column.substring(column.indexOf('_') + 1)));
			}
		}, this));

		return columns;
	},
	getCompanyCustomFieldColumns: function (view) {
		let setting = this.getSettings(view), columns = [];
		_.each(setting.columns, _.bind(function (column) {
			if (column.startsWith('companyCustomField_')) {
				columns.push(parseInt(column.substring(column.indexOf('_') + 1)));
			}
		}, this));

		return columns;
	}
});

PJQ.models.addressBook.AddressBookAdvancedSearchSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'advancedsearch'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.models.addressBook.ProqualStatistics = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'proqual'
			},
			{
				endpoint: 'stats'
			}
		]);
	}
});

PJQ.models.addressBook.ProqualSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'proqual'
			},
			{
				endpoint: 'settings'
			}
		]);
	}
});

PJQ.collections.addressBook = {};
PJQ.collections.addressBook.AddressBookViewResults = PJQ.collections.BaseCollection.extend({
	beforeConstruct: function (models, options) {
		switch (options.view) {
			case PJQ.constants.addressBook.view.CONTACT:
			case PJQ.constants.addressBook.view.COMPANY_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
			case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
			case PJQ.constants.addressBook.view.COMPANY:
				this.model = PJQ.models.contacts.Contact;
				break;
		}
	},
	endpoint: function (urlOptions) {
		let endpointArr = [
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'views'
			},
			{
				endpoint: this.options.view
			}
		];

		if (urlOptions && urlOptions.isExport)
			endpointArr.push({endpoint: 'export'});

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	},
	parse: function (data) {
		if (this.options.isExport) {
			this.exportURL = data.url;
		}
		else {
			this.totalRows = 0;
			if (data) {
				this.totalRows = data.totalRows;
				return data.rows;
			}
		}
		return null;
	},
	export: function (data, callback) {
		if (typeof callback !== 'function') {
			return;
		}
		new PJQ.ajax.Request({
			endpoint: this.endpoint({
				isExport: true
			}),
			type: 'POST',
			timeout: 600000,
			data: data
		}).post().done(function (response) {
			callback(response);
		}).fail(function () {
			callback(null);
		});
	}
});

PJQ.collections.addressBook.AddressBookSelections = PJQ.collections.BaseCollection.extend({
	endpoint: function () {
		let endpointArr = [
			{
				endpoint: 'addressbook'
			},
			{
				endpoint: 'selection'
			}
		];

		return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr);
	}
});

PJQ.views.addressbook.AddressBook = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'AddressBook'),
        selectContactGroupsMode: false,
        isShowHeader: true,
        directoryFilter: PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
        selectionMode: PJQ.constants.addressBook.selectionMode.NONE,
        disabledContacts: [],
        disabledContactGroups: [],
        onSelection: _.noop
    },
    events: {
        'keyup .input-search': 'searchChanged',
        'click .basic-search': 'search',
        'click .advanced-search': 'advancedSearch',
        'click .filter-groups': 'filterGroups',
        'click .clear-search': 'clearFilter',
        'click .btn-address-book-settings': 'settings',
        'click a.import': 'import',
        'click a.export': 'export',
        'click .merge': 'beginMerge',
        'click .merge-continue': 'continueMerge',
        'click .merge-cancel': 'cancelMerge',
        'click .new-contact': 'addContactClicked',
        'click .proqual-screening': 'proqualScreening',
        'click .proqual-filter>div': 'proqualFilterClicked',
        'click .btn-approval-queue': 'viewApprovalQueue',
        'click a.updaters': 'beginSendUpdater',
        'click .updater-continue': 'continueUpdater',
        'click .updater-cancel': 'cancelUpdater',
        'click .qualifications-report': 'qualificationsReport'
    },
    viewApprovalQueue: function () {
        this.approvalQueueSelector.setValue([1]);
        this.renderView();
    },
    onApprove() {
        let apprCount = PJQ.app.session.set('unApprovedContactsCount');
        if (apprCount == null) {
            apprCount = 0;
        } else if (apprCount <= 0) {
            apprCount = 0;
        } else {
            apprCount--;
        }
        PJQ.app.session.set('unApprovedContactsCount', apprCount);
        this.renderApprovalHeader();
    },
    fetchStats: function () {
        new PJQ.ajax.Request({
            endpoint: '/addressbook/stats'
        }).get().done(_.bind(function (data) {
            PJQ.app.session.set('unApprovedContactsCount', data.unApprovedContactsCount);
            this.renderApprovalHeader();
        }, this));
    },
    renderApprovalHeader: function () {
        let $alert = this.$('.approval-alert');
        $alert.empty();
        if (PJQ.app.session.get('unApprovedContactsCount') > 0) {
            new PJQ.Alert($alert, {
                text: PJQ.app.session.get('unApprovedContactsCount').toString() + ' contacts are in the approval queue.  <a href="javascript:void(0)" class="btn-approval-queue font-weight-bold" style="text-decoration: underline !important;">Click here</a> or filter to unapproved contacts to review them.'
            });
        }
    },
    beforeFirstRender: function () {
        this.isAdvancedSearch = false;
        this.isShowCheckboxes = false;
        this.isMerge = false;
        this.showApproval = this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE && (PJQ.app.session.hasPermission('contacts.canApprove') || PJQ.app.session.hasPermission('contacts.canViewApproval'));
        this.showLaborStatus = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
        this.isInitialLoad = true;

        this.advancedSearch = null;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            this.isShowCheckboxes = true;
            this.isShowHeader = false;
        }

        this.isSettingsFetched = false;
        this.filter = {
            searchFor: '',
            locationFilter: PJQ.constants.addressBook.locationTypeFilter.WORK_AREA,
            zip: '',
            radius: 0,
            directoryFilter: PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
            userTypeFilter: 0,
            groups: []
        };

        this.proqualStatistics = new PJQ.models.addressBook.ProqualStatistics();
        this.settings = new PJQ.models.addressBook.AddressBookViewSettings();
        this.settings.fetch({
            success: _.bind(function () {
                this.isSettingsFetched = true;
                this.currentView = this.settings.get('defaultView');
                PJQ.app.session.fetchCompanyCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                    PJQ.app.session.fetchContactCustomFields(PJQ.app.session.get("masterUserId"), _.bind(function () {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
                            this.proqualStatistics.fetch({
                                success: _.bind(function () {
                                    PJQ.app.session.fetchScreeningSettings(_.bind(function (settings) {
                                        this.screeningSettings = settings;
                                        this.render();
                                    }, this))
                                }, this)
                            });
                        } else
                            this.render();
                    }, this));
                }, this));
            }, this)
        });
    },
    renderData: function () {
        return {
            showHeader: this.options.isShowHeader,
            showScreenings: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS),
            showProqual: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER),
            proqualStatistics: this.proqualStatistics.attributes,
            showGroupCompanyView: true, // todo: read from preferences
            showGroupContactView: true, // todo: read from preferences
            showApproval: this.showApproval,
            showLaborStatus: this.showLaborStatus,
            canAdd: PJQ.app.session.hasPermission('contacts.canAddContact'),
            settingsFetched: this.isSettingsFetched,
            selectionMode: this.options.selectionMode,
            canExport: PJQ.app.session.hasPermission('contacts.canExport'),
            canImport: PJQ.app.session.hasPermission('contacts.canImport'),
            canMerge: PJQ.app.session.hasPermission('contacts.canMerge')
        };
    },
    afterRender: function () {
        if (!this.isSettingsFetched)
            return;

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            this.$('.proqual-screening, .other-actions').prop('disabled', true);
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.address-book-view'),
            defaultValue: this.currentView,
            onChange: _.bind(function (value) {
                this.isInitialLoad = true;
                this.renderView(value);
            }, this)
        });

        if (this.showApproval) {
            this.fetchStats();
            this.approvalQueueSelector = new PJQ.inputs.Selectpicker({
                el: this.$('.select-approval'),
                isIntChoices: true,
                defaultValue: [0],
                isMultiple: true,
                noneSelectedText: "Select Approval Status",
                onChange: _.bind(function () {
                    if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
                        this.renderView();
                    }
                }, this)
            });
        }

        this.locationType = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS).split(',') : [PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION]
        this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-location-type'),
            isIntChoices: true,
            isMultiple: true,
            mustSelectValue: true,
            defaultValue: this.locationType
        });

        this.radiusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-radius'),
            isIntChoices: true,
            defaultValue: 0
        });

        /* not sure this is needed given how new UI works
        let publicContactInfo = 'You must enter a search zip code to view public subcontractors.';
        if (this.options.directoryFilter === PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS ||
            this.options.directoryFilter === PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY) {
            this.showNotification(publicContactInfo, 'info');
        }
         */
        let defaultFilters = null
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS)) {
            defaultFilters = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS).split(',');
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        } else {
            defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
                return userType.get('userTypeId');
            });

            $.merge(defaultFilters, [PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);
            if (this.showLaborStatus)
                $.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        }

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY)) {
            switch (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY)) {
                case 0:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY, PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY]);
                    break;
                case 1 || -1:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY]);
                    break;
                default:
                    $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY]);
            }
        } else {
            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY])
        }

        this.filterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter'),
            isIntChoices: true,
            isMultiple: true,
            exclusiveChoices: [-3, -4],
            isGroup: true,
            mustSelectValuePerOptGroup: true,
            defaultValue: defaultFilters,
            onHide: _.bind(function () {
                if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
                    if ((_.size(this.lastFilter) !== _.size(this.filterSelectPicker.getValue())) ||
                        (_.size(this.lastFilter) !== _.size(_.uniq(_.union(this.lastFilter, this.filterSelectPicker.getValue())))))
                        this.renderView();
                }
            }, this)
        });
        this.renderView();
    },
    hideNotification: function () {
        this.$('.address-book-notifications').hide();
    },
    showNotification: function (content, type) {
        this.$('.address-book-notifications').removeClass('alert-primary').removeClass('alert-secondary').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').removeClass('alert-danger');
        this.$('.address-book-notifications').addClass('alert-' + type);

        let icon = '';
        switch (type) {
            case 'info':
                icon = '<i class="fas fa-info-circle fa-xs"></i>';
                break;
        }

        this.$('.address-book-notifications').html(icon + (icon ? ' ' : '') + content);
        this.$('.address-book-notifications').show();
    },
    renderView: function (view, options = {}) {
        this.currentView = view ? view : this.currentView;

        let page = null;
        if (options.stayOnPage && this.dataTable != null) {
            page = this.dataTable.dataTable.page();
        }

        if (this.dataTable) {
            this.dataTable.cleanup();
            this.dataTable.clearServerCache = true;
            this.dataTable.pageCache = [];
            this.dataTable.remove();
            this.dataTable = null;
            this.$('.addressbook-data').empty();
        }

        let tableSettings = this.settings.getSettings(this.currentView),
            dataTableOptions = {
                el: this.$('.addressbook-data'),
                language: {
                    zeroRecords: (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH) && this.isInitialLoad) ? " " : "No Results Available"
                },
                data: null,
                view: this.currentView,
                addressBookView: this,
                userSettings: this.settings,
                settings: tableSettings,
                getPageCallback: _.bind(this.getViewData, this),
                displayStart: page != null ? page * tableSettings.rowsPerPage : null,
                deferRender: true,
                clearServerCache: true,
                isShowCheckboxes: this.isShowCheckboxes,
                onApprove: _.bind(this.onApprove, this),
                showPageSelector: true,
                onTableDraw: _.bind(function (dataTable) {
                    this.$('.addressbook-data').css('margin-top', -40);
                }, this)
            };

        this.dataTable = this.getDataTableInstance(dataTableOptions);

        if (this.options.contactId > 0) {
            let initContact = new PJQ.models.contacts.Contact({
                id: this.options.contactId
            });
            this.options.contactId = null;
            initContact.fetch({
                success: _.bind(function () {
                    this.dataTable.editContact(initContact);
                }, this)
            })
        }
    },
    updateFilter: function () {
        if ((PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH) && !this.isInitialLoad) || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH)) {
            let filter = this.filterSelectPicker.getValue();
            this.lastFilter = filter;

            this.filter.searchFor = this.$('.input-search').val();

            if (this.filter.searchFor.length <= 15 && PJQ.helpers.formatHelpers.numbersOnly(this.filter.searchFor).length == 10)
                this.filter.searchFor = PJQ.helpers.formatHelpers.numbersOnly(this.filter.searchFor);

            this.filter.locationFilter = 0;
            if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.WORK_AREA) !== -1 && this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.BOTH;
            else if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.WORK_AREA) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.WORK_AREA;
            else if (this.locationTypeSelectPicker.getValue().indexOf(PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION) !== -1)
                this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION;

            this.filter.zip = this.$('.input-search-zip').val().replace(' ', '').replace('-', '');
            if (_.size(this.filter.zip) === 6) {
                this.filter.zip = this.filter.zip.substring(0, 3) + ' ' + this.filter.zip.substring(3, 6);
            }
            this.filter.radius = this.radiusSelectPicker.getValue();

            this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS;
            if (filter.indexOf(PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY) === -1)
                this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY * -1;
            else if (filter.indexOf(PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY) === -1)
                this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY * -1;

            let $exportBtn = this.$('.dropdown-item.export'),
                $alert = this.$('.public-zip-alert');
            $alert.empty();
            if (this.filter.directoryFilter === PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS || this.filter.directoryFilter === PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY * -1) {
                new PJQ.Alert($alert, {
                    text: 'You must enter a search ZIP Code to view public subcontractors.'
                });
                $exportBtn.addClass('hidden');
            } else {
                $exportBtn.removeClass('hidden');
            }

            this.filter.userTypeFilter = _.filter(filter, function (value) {
                return value > 0;
            });

            this.filter.isPrimaryOnly = filter.indexOf(PJQ.constants.addressBook.miscFilter.PRIMARY_CONTACT_ONLY) !== -1;

            this.filter.isFilterActive = filter.indexOf(PJQ.constants.addressBook.contactStatusFilter.ACTIVE) !== -1;
            this.filter.isFilterInactive = filter.indexOf(PJQ.constants.addressBook.contactStatusFilter.INACTIVE) !== -1;

            this.filter.isFilterUnion = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.UNION) !== -1;
            this.filter.isFilterNonUnion = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.NON_UNION) !== -1;
            this.filter.isFilterPrevWage = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE) !== -1;
            this.filter.isFilterNoLaborStatus = filter.indexOf(PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE) !== -1;

            this.filter.isFilterApproved = this.approvalQueueSelector && this.approvalQueueSelector.getValue().indexOf(0) !== -1;
            this.filter.isFilterUnapproved = this.approvalQueueSelector && this.approvalQueueSelector.getValue().indexOf(1) !== -1;

            this.filter.proqualFilter = this.$('div.proqual-filter>div.selected').data('filter');
        } else {
            this.isInitialLoad = false;
        }
    },
    getViewData: function (pageNumber, pageSize, orderArr, callback) {
        this.updateFilter();

        let order = orderArr[0];
        this.data = new PJQ.collections.addressBook.AddressBookViewResults(null, {
            view: this.currentView
        });

        switch (this.currentView) {
            case PJQ.constants.addressBook.view.COMPANY:
                switch (order.name) {
                    case 'contactName':
                        order.name = 'primaryContactName';
                        break;
                    case 'contactTitle':
                        order.name = 'primaryContactTitle';
                        break;
                    case 'contactUserType':
                        order.name = 'primaryContactUserType';
                        break;
                    case 'contactAddress1':
                        order.name = 'primaryAddress1';
                        break;
                    case 'contactAddress2':
                        order.name = 'primaryAddress2';
                        break;
                    case 'city':
                        order.name = 'primaryCity';
                        break;
                    case 'state':
                        order.name = 'primaryState';
                        break;
                    case 'zip':
                        order.name = 'primaryZip';
                        break;
                    case 'country':
                        order.name = 'primaryCountry';
                        break;
                    case 'phone':
                        order.name = 'primaryPhone';
                        break;
                    case 'fax':
                        order.name = 'primaryFax';
                        break;
                    case 'cell':
                        bid - form - estimate
                        order.name = 'primaryCell';
                        break;
                    case 'email':
                        order.name = 'primaryEmail';
                        break;
                }
                break;
        }

        this.data.fetch({
            data: {
                searchFor: this.filter.searchFor,
                locationFilter: this.filter.locationFilter,
                zip: this.filter.zip,
                radius: this.filter.radius,
                directoryFilter: this.filter.directoryFilter,
                userTypeFilter: this.filter.userTypeFilter,
                groups: this.filter.groups,
                page: pageNumber,
                pageSize: pageSize,
                orderBy: order.name,
                orderDirection: order.direction,
                isAdvancedSearch: this.isAdvancedSearch,
                advancedSearch: this.advancedSearch,
                showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
                isPrimaryOnly: this.filter.isPrimaryOnly,
                isFilterApproved: this.filter.isFilterApproved,
                isFilterUnapproved: this.filter.isFilterUnapproved,
                proqualFilter: this.filter.proqualFilter,
                isFilterActive: this.filter.isFilterActive,
                isFilterInactive: this.filter.isFilterInactive,
                isFilterUnion: this.filter.isFilterUnion,
                isFilterNonUnion: this.filter.isFilterNonUnion,
                isFilterPrevWage: this.filter.isFilterPrevWage,
                isFilterNoLaborStatus: this.filter.isFilterNoLaborStatus,
                isIncludeGroupList: this.settings.hasGroupListColumn(this.currentView),
                includeScreeningPackages: this.settings.hasScreeningPackagesColumn(this.currentView),
                includeContactCustomFields: this.settings.getContactCustomFieldColumns(this.currentView),
                includeCompanyCustomFields: this.settings.getCompanyCustomFieldColumns(this.currentView),
                isSelectionMode: !(this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
            },
            type: 'POST',
            success: _.bind(function () {
                callback(this.data.models, this.data.totalRows);
                if (this.pageSelectPicker == null) {
                    // this.renderPageSelect();
                }
            }, this),
            fail: _.bind(function () {
                callback();
            }, this)
        });
    },
    getDataTableInstance: function (options) {
        let dataTable = null;

        switch (options.view) {
            case PJQ.constants.addressBook.view.CONTACT:
            case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
            case PJQ.constants.addressBook.view.COMPANY_CONTACT:
            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
                dataTable = new PJQ.views.addressbook.ContactDataTable(options);
                break;
            case PJQ.constants.addressBook.view.COMPANY:
            case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
                dataTable = new PJQ.views.addressbook.CompanyDataTable(options);
                break;
            case PJQ.constants.addressBook.view.TRADES_COMPANY:
            case PJQ.constants.addressBook.view.TRADES_CONTACT:
                dataTable = new PJQ.views.addressbook.GroupHeaderDataTable(options);
                break;
            case PJQ.constants.addressBook.view.CONTACT_GROUP:
                dataTable = new PJQ.views.addressbook.ContactGroupDataTable(options);
                break;
        }
        return dataTable;
    },
    selectAll: function (checked, groupDescription, callback) {
        let selections = new PJQ.collections.addressBook.AddressBookSelections();
        selections.fetch({
            data: {
                searchFor: this.filter.searchFor,
                locationFilter: this.filter.locationFilter,
                zip: this.filter.zip,
                radius: this.filter.radius,
                directoryFilter: this.filter.directoryFilter,
                userTypeFilter: this.filter.userTypeFilter,
                groups: this.filter.groups,
                isAdvancedSearch: this.isAdvancedSearch,
                advancedSearch: this.advancedSearch,
                showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
                groupDescription: groupDescription,
                isPrimaryOnly: this.filter.isPrimaryOnly || (this.proqualRequest != null),
                isFilterApproved: this.filter.isFilterApproved,
                isFilterUnapproved: this.filter.isFilterUnapproved,
                proqualFilter: this.filter.proqualFilter,
                isFilterActive: this.filter.isFilterActive,
                isFilterInactive: this.filter.isFilterInactive,
                isFilterUnion: this.filter.isFilterUnion,
                isFilterNonUnion: this.filter.isFilterNonUnion,
                isFilterPrevWage: this.filter.isFilterPrevWage,
                isFilterNoLaborStatus: this.filter.isFilterNoLaborStatus,
                isSelectionMode: !(this.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
            },
            type: 'POST',
            success: _.bind(function () {

                let contacts = [], contactGroups = [], contactsNoGroup = [];
                _.each(selections.models, _.bind(function (selection) {
                    contacts.push(selection.get('contactId'));
                    if (_.size(selection.get('groups')) > 0) {
                        $.merge(contactGroups, selection.get('groups'));
                    } else {
                        contactsNoGroup.push(selection.get('contactId'));
                    }
                }, this));

                if (checked) {
                    this.addSelectedContactsAll(contacts);
                    this.addSelectedContactGroups(contactGroups);
                    this.addSelectedContactsNoGroup(contactsNoGroup);
                } else {
                    this.removeSelectedContactsAll(contacts);
                    this.removeSelectedContactGroups(contactGroups);
                    this.removeSelectedContactsNoGroup(contactsNoGroup);
                }

                callback();
            }, this)
        });

    },
    enableBasicSearch: function (enabled) {
        this.$('.input-search,.input-search-zip,.filter-groups,.basic-search, input.proqual-filter').prop('disabled', !enabled);

        if (!enabled)
            this.$('div.proqual-filters label').removeClass('active');

        if (enabled) {
            this.locationTypeSelectPicker.enable();
            this.radiusSelectPicker.enable();
            this.filterSelectPicker.enable();
        } else {
            this.locationTypeSelectPicker.disable();
            this.radiusSelectPicker.disable();
            this.filterSelectPicker.disable();
        }
    },
    filterGroups: function () {
        this.updateFilter();
        new PJQ.views.addressbook.FilterTradesModal({
            directoryFilter: this.filter.directoryFilter,
            selectedGroups: this.filter.groups,
            onFilter: _.bind(function (groups) {
                this.filter.groups = groups;
                this.$('.filter-groups-text').text((groups.length > 0 ? groups.length.toString() : 'All') + ' Trades');
                this.renderView();
            }, this)
        });
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function () {
        this.renderView();
    },
    advancedSearch: function () {
        let settings = new PJQ.models.addressBook.AddressBookAdvancedSearchSettings();
        settings.fetch({
            success: _.bind(function (data) {
                new PJQ.views.addressbook.AdvancedSearchModal({
                    advancedSearch: this.advancedSearch,
                    settings: settings,
                    onSearch: _.bind(function (search) {
                        this.isAdvancedSearch = true;
                        this.advancedSearch = search;
                        this.clearBasicSearch();
                        this.enableBasicSearch(false);
                        this.renderView();
                    }, this)
                });
            }, this)
        });

    },
    clearBasicSearch() {
        if ((PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_DEFAULT_SEARCH))) {
            this.isInitialLoad = true;
        }
        this.filter.searchFor = '';
        this.$('.input-search').val(this.filter.searchFor);

        this.filter.locationFilter = PJQ.constants.addressBook.locationTypeFilter.BOTH;
        this.locationTypeSelectPicker.setValue([PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION]);

        this.filter.zip = '';
        this.$('.input-search-zip').val(this.filter.zip);

        this.filter.radius = 0;
        this.radiusSelectPicker.setValue(this.filter.radius);

        this.filter.directoryFilter = PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY;
        this.filter.userTypeFilter = PJQ.app.session.userTypes.getByIsCompany(false)[0].get('userTypeId');
        this.filter.isFilterUnapproved = false;

        let defaultFilters = null
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS)) {
            defaultFilters = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_FILTERS).split(',')
            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY])
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        } else {
            defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
                return userType.get('userTypeId');
            });

            $.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY, PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);

            if (this.showLaborStatus)
                $.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
            if (this.showApproval)
                defaultFilters.push(PJQ.constants.addressBook.approvalFilter.APPROVED);
        }
        this.filterSelectPicker.setValue(defaultFilters);

        this.filter.groups = [];
        this.$('.filter-groups-text').text('All Trades');

        this.$('div.proqual-filters label').removeClass('active');
        this.$('input.proqual-filter-all').prop('checked', true).closest('label').addClass('active');
    },
    clearFilter: function (preventRefresh) {
        this.clearBasicSearch();
        this.isAdvancedSearch = false;
        this.advancedSearch = null;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];

        if (preventRefresh !== true) {
            this.enableBasicSearch(true);
            this.renderView();
        }
    },
    settings: function () {
        new PJQ.views.addressbook.AddressBookSettingsModal({
            addressBookView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    import: function () {
        new PJQ.views.contacts.ContactsImportModal({
            onClose: _.bind(function (isChanged) {
                if (isChanged) {
                    this.renderView();
                }
            }, this)
        });
    },
    export: function () {
        this.updateFilter();

        let orderBy = '', orderDirection = '', settings = null;

        switch (this.currentView) {
            case PJQ.constants.addressBook.view.TRADES_COMPANY:
            case PJQ.constants.addressBook.view.COMPANY:
                settings = this.settings.getSettings(PJQ.constants.addressBook.view.COMPANY);

                orderBy = settings.orderBy;
                orderAscending = settings.orderAscending ? 'asc' : 'desc';
                switch (orderBy) {
                    case 'contactName':
                        orderBy = 'primaryContactName';
                        break;
                    case 'contactTitle':
                        orderBy = 'primaryContactTitle';
                        break;
                    case 'contactAddress1':
                        orderBy = 'primaryAddress1';
                        break;
                    case 'contactAddress2':
                        orderBy = 'primaryAddress2';
                        break;
                    case 'city':
                        orderBy = 'primaryCity';
                        break;
                    case 'state':
                        orderBy = 'primaryState';
                        break;
                    case 'zip':
                        orderBy = 'primaryZip';
                        break;
                    case 'country':
                        orderBy = 'primaryCountry';
                        break;
                    case 'phone':
                        orderBy = 'primaryPhone';
                        break;
                    case 'fax':
                        orderBy = 'primaryFax';
                        break;
                    case 'cell':
                        orderBy = 'primaryCell';
                        break;
                    case 'email':
                        orderBy = 'primaryEmail';
                        break;
                }
                break;
            case PJQ.constants.addressBook.view.TRADES_CONTACT:
            case PJQ.constants.addressBook.view.CONTACT:
                settings = this.settings.getSettings(PJQ.constants.addressBook.view.CONTACT);
                orderBy = settings.orderBy;
                orderDirection = settings.orderAscending ? 'asc' : 'desc';
                break;
        }

        this.loader = new PJQ.Loader(this.$el);
        let dateNow = new Date(), vw = new PJQ.collections.addressBook.AddressBookViewResults(null, {
            view: this.currentView,
            isExport: true
        });
        vw.export({
            searchFor: this.filter.searchFor,
            locationFilter: this.filter.locationFilter,
            zip: this.filter.zip,
            radius: this.filter.radius,
            directoryFilter: this.filter.directoryFilter,
            userTypeFilter: this.filter.userTypeFilter,
            groups: this.filter.groups,
            page: 1,
            pageSize: 2147483646,
            orderBy: orderBy,
            orderDirection: orderDirection,
            isAdvancedSearch: this.isAdvancedSearch,
            advancedSearch: this.advancedSearch,
            showGroupDescription: this.settings.getSettings(this.currentView).showGroupDescription,
            isPrimaryOnly: this.filter.isPrimaryOnly,
            isFilterApproved: this.filter.isFilterApproved,
            isFilterUnapproved: this.filter.isFilterUnapproved,
            isFilterActive: this.filter.isFilterActive,
            isFilterInactive: this.filter.isFilterInactive,
            proqualFilter: this.filter.proqualFilter,
            isIncludeGroupList: this.settings.hasGroupListColumn(this.currentView),
            includeScreeningPackages: this.settings.hasScreeningPackagesColumn(this.currentView),
            includeContactCustomFields: this.settings.getContactCustomFieldColumns(this.currentView),
            includeCompanyCustomFields: this.settings.getCompanyCustomFieldColumns(this.currentView),
            timeZoneOffset: dateNow.getTimezoneOffset()
        }, _.bind(function (response) {
            this.loader.remove();
            if (response != null) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Export failed.'
                });
            }
        }, this));
    },
    qualificationsReport: function() {
        new PJQ.views.addressbook.QualificationsReportModal();
    },
    addContactClicked: function () {
        new PJQ.views.addressbook.EditCompanyModal({
            onSave: _.bind(function () {
                this.renderView(null, {
                    stayOnPage: true
                });
            }, this),
            onSaveContact: _.bind(function (contact, isNew) {
                if (isNew) {
                    this.addSelectedContactsAll([contact.get('contactId')]);
                    if (_.size(contact.get('contactGroups')) > 0) {
                        this.addSelectedContactGroups(contact.get('contactGroups'));
                    } else {
                        this.addSelectedContactsNoGroup([contact.get('contactId')]);
                    }
                }
            }, this),
            onApprove: _.bind(function () {
                this.fetchStats();
            }, this),
            onDelete: _.bind(function () {
                this.renderView(null, {
                    stayOnPage: true
                });
            }, this)
        });
    },
    proqualFilterClicked: function (e) {
        let $target = $(e.currentTarget),
            filter = $target.data('filter');
        this.$('.proqual-filter>div').removeClass('selected');
        $target.addClass('selected');
        this.renderView();
    },
    proqualScreening: function () {
        let request = this.proqualRequest ? this.proqualRequest : {};
        request.selectedContacts = this.selectedContactsAll;
        this.$('button.other-actions').prop('disabled', true);

        new PJQ.views.addressbook.ProqualRequestModal({
            request: request,
            onAddParticipants: _.bind(function (request) {
                // 2020-06-10 Per request they want to SEE all the contacts, but when they do SELECT ALL they want it to only select primary.   Therefore removing this auto-filter.
                //this.filterSelectPicker.setValue(_.union(this.filterSelectPicker.getValue(), [PJQ.constants.addressBook.miscFilter.PRIMARY_CONTACT_ONLY]));
                this.proqualRequest = request;
                this.$('.proqual-screening').html('<i class="fal fa-paper-plane mr-1"></i>Resume Qualifications');
                if (!this.isShowCheckboxes) {
                    this.isShowCheckboxes = true;
                    this.options.selectionMode = PJQ.constants.addressBook.selectionMode.PROQUAL;
                    this.renderView();
                }
            }, this),
            onClose: _.bind(function () {
                this.$('button.other-actions').prop('disabled', false);
                this.$('.proqual-screening').html('<i class="fal fa-paper-plane mr-1"></i>Request Qualifications');
                this.proqualRequest = null;
                if (this.isShowCheckboxes) {
                    this.isShowCheckboxes = false;
                    this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
                    this.selectedContactsAll = [];
                    this.selectedContactGroups = [];
                    this.selectedContactsNoGroup = [];
                    this.renderView();
                }
            }, this)
        });
    },
    addSelectedContactsAll: function (contactIds) {
        this.selectedContactsAll = _.uniq(_.union(contactIds, this.selectedContactsAll));

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.MERGE) {
            this.$('.merge-continue').prop('disabled', (_.size(this.selectedContactsAll) < 2));
        }
        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.UPDATER) {
            this.$('.updater-continue').prop('disabled', (_.size(this.selectedContactsAll) < 1));
        }

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactsAll: function (contactIds) {
        this.selectedContactsAll = _.without(this.selectedContactsAll, ...contactIds);

        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.MERGE) {
            this.$('.merge-continue').prop('disabled', (_.size(this.selectedContactsAll) < 2));
        }
        if (this.options.selectionMode === PJQ.constants.addressBook.selectionMode.UPDATER) {
            this.$('.updater-continue').prop('disabled', (_.size(this.selectedContactsAll) < 1));
        }

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    addSelectedContactGroups: function (contactGroupIds) {
        if (this.options.disabledContactGroups == null) {
            this.options.disabledContactGroups = [];
        }
        this.selectedContactGroups = _.without(_.uniq(_.union(contactGroupIds, this.selectedContactGroups)), ...this.options.disabledContactGroups);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactGroups: function (contactGroupIds) {
        this.selectedContactGroups = _.without(this.selectedContactGroups, ...contactGroupIds);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    addSelectedContactsNoGroup: function (contactIds) {
        this.selectedContactsNoGroup = _.without(_.uniq(_.union(contactIds, this.selectedContactsNoGroup)), ...this.options.disabledContacts);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    removeSelectedContactsNoGroup: function (contactIds) {
        this.selectedContactsNoGroup = _.without(this.selectedContactsNoGroup, ...contactIds);

        this.options.onSelection(this.selectedContactsAll, this.selectedContactsNoGroup, this.selectedContactGroups);
    },
    beginMerge: function () {
        this.isShowCheckboxes = true;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.MERGE;
        this.$('.other-actions, .proqual-screening, .merge-continue, .merge').prop('disabled', true);
        this.$('.merge-continue, .merge-cancel').show();
        this.showNotification('Select 2 or more contacts and click "Continue Merge" to continue.', 'info');
        this.renderView(null, {
            stayOnPage: true
        });
    },
    continueMerge: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'merge'
            },
            {
                endpoint: 'check'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                contacts: this.selectedContactsAll
            }
        }).post().done(_.bind(function (data) {
            if (_.size(data.response) < 2) {
                PJQ.notifications.notify.errorNotify({
                    title: 'Nothing to Merge!',
                    message: 'All selected contacts already belong to the same company.'
                });

                return;
            }

            new PJQ.views.addressbook.MergeRequestModal({
                data: data.response,
                addressBookView: this,
                onMerge: _.bind(function () {
                    this.cancelMerge();
                }, this)
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    cancelMerge: function () {
        this.isShowCheckboxes = false;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];
        this.$('.other-actions, .proqual-screening, .merge').prop('disabled', false);
        this.$('.merge-continue, .merge-cancel').hide();
        this.hideNotification();
        this.renderView();
    },
    beginSendUpdater: function (e) {
        let $target = $(e.currentTarget);
        this.updaterType = $target.data('updater');
        this.isShowCheckboxes = true;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.UPDATER;
        this.$('.other-actions, .proqual-screening, .updater-continue, .btn-merge').prop('disabled', true);
        this.$('.updater-continue, .updater-cancel').show();
        this.showNotification('Select 1 or more contacts and click "Send Updater" to continue.', 'info');
        this.renderView(null, {
            stayOnPage: true
        });
    },
    continueUpdater: function () {
        let endpoint,
            header;
        if (this.updaterType === 'contact') {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'updater'
                }
            ]);
            header = "Send Contact Updaters"
        } else if (this.updaterType === 'prequal') {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'request'
                }
            ]);
            header = "Send Qualification Updaters"
        }
        new PJQ.views.modals.YesNo({
            header: header,
            body: 'Are you sure you want to send these contacts an Update Request?',
            onYes: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: endpoint,
                    data: {
                        contacts: this.selectedContactsAll
                    }
                }).post().done(_.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Successfully sent contact updaters'
                    });
                    this.cancelUpdater();
                }, this)).fail(function (xhr, err, result) {
                });
            }, this),
            onNo: _.bind(function () {
                this.cancelUpdater();
            }, this)
        })

    },
    cancelUpdater: function () {
        this.updaterType = null;
        this.isShowCheckboxes = false;
        this.options.selectionMode = PJQ.constants.addressBook.selectionMode.NONE;
        this.selectedContactsAll = [];
        this.selectedContactGroups = [];
        this.selectedContactsNoGroup = [];
        this.$('.other-actions, .proqual-screening, .btn-merge').prop('disabled', false);
        this.$('.updater-continue, .updater-cancel').hide();
        this.hideNotification();
        this.renderView();
    }
});

// Modals
PJQ.views.addressbook.FilterTradesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Filter-Trades'),
        minWidth: '800px',
        directoryFilter: -1 * PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY,
        selectedGroups: []
    },
    events: {
        'click button.clear-all': 'clearAll',
        'click button.filter': 'filter'
    },
    afterRender: function () {
        let hasGroupsLinked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HAS_GROUPS_LINKED),
            showPublic = false, showPrivate = false;

        switch (this.options.directoryFilter * -1) {
            case PJQ.constants.addressBook.directoryFilter.ALL_CONTACTS:
                showPrivate = true;
                showPublic = !hasGroupsLinked;
                break;
            case PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY:
                showPrivate = true;
                showPublic = false;
                break;
            case PJQ.constants.addressBook.directoryFilter.PUBLIC_ONLY:
                showPrivate = hasGroupsLinked;
                showPublic = !hasGroupsLinked;
                break;
        }

        if (!showPrivate) {
            this.$('.filter-groups').hide();
            this.$('.filter-groups-public').show();
        }

        if (!showPublic || !showPrivate)
            this.$('.trade-type').hide();

        if (showPrivate && showPublic) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.trade-type'),
                isIntChoices: true,
                defaultValue: 0,
                onChange: _.bind(function (value) {
                    if (value === 0) {
                        this.$('.filter-groups').show();
                        this.$('.filter-groups-public').hide();
                    } else {
                        this.$('.filter-groups').hide();
                        this.$('.filter-groups-public').show();
                    }
                }, this)
            });
        }

        if (showPrivate) {
            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.filter-groups'),
                isShowNoGroup: true,
                selectedGroupIds: this.options.selectedGroups
            });
        }

        if (showPublic) {
            this.groupSelectorPublic = new PJQ.views.groups.GroupSelector({
                el: this.$('.filter-groups-public'),
                isShowNoGroup: false,
                isPublicGroups: true,
                selectedGroupIds: this.options.selectedGroups
            });
        }
    },
    clearAll: function () {
        if (this.groupSelector)
            this.groupSelector.selectAll(false);
        if (this.groupSelectorPublic)
            this.groupSelectorPublic.selectAll(false);

    },
    filter: function () {
        let groups = [];

        if (this.groupSelector)
            groups = _.union(groups, _.map(this.groupSelector.getGroupsData().selected, function (group) {
                return group.get('groupId');
            }));

        if (this.groupSelectorPublic)
            groups = _.union(groups, _.map(this.groupSelectorPublic.getGroupsData().selected, function (group) {
                return group.get('groupId');
            }));

        if (typeof this.options.onFilter === 'function')
            this.options.onFilter(groups);

        this.removeModal();
    }
});

PJQ.views.addressbook.AddressBookSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-addressbook-settings'),
        width: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.model = this.options.addressBookView.settings;
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.model.get('defaultView');
        _.each(this.model.attributes.settings, _.bind(function (setting) {
            if (setting.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP ||
                setting.view === PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP)
                return;

            let columns = this.options.addressBookView.getDataTableInstance({
                    view: setting.view,
                    settings: this.model.getSettings(setting.view)
                }).getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns,
                showGroupDescription: setting.showGroupDescription
            });
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            showGroupCompanyView: true, // todo: read from preferences
            showGroupContactView: true // todo: read from preferences
        }
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.addressBookView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)

        });

        this.$('input.show-group-description').change(_.bind(function () {
            this.currentView.showGroupDescription = this.$('input.show-group-description').prop('checked');
        }, this));

        this.selectView(this.options.addressBookView.dataTable.options.view);
    },
    editCompanySettings: function () {
        this.model = new PJQ.models.addressBook.AddressBookViewSettings(null, {
            forCompany: true
        });
        this.model.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (view === PJQ.constants.addressBook.view.TRADES_COMPANY || view === PJQ.constants.addressBook.view.TRADES_CONTACT) {
            this.$('div.show-group-description').show();
            this.$('input.show-group-description').prop('checked', this.currentView.showGroupDescription);
            this.$('div.select-columns').hide();
        } else {
            this.$('div.show-group-description').hide();
            this.$('div.select-columns').show();

            if (this.dataTable) {
                this.dataTable.undelegateEvents();
                $(this.dataTable.el).empty();
            }

            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('div.select-columns-datatable'),
                data: this.currentView.columns,
                isHideSearch: true,
                order: [],
                columns: [
                    {"data": "title", "title": "Column", "orderable": false},
                    {
                        "data": "visible",
                        "title": "Show",
                        "orderable": false,
                        "searchable": false,
                        "render": _.bind(function (data) {
                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '10%'
                    }
                ],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
            });
        }
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let forCompany = this.model.get('userId') === PJQ.app.session.get('masterUserId'),
            fnOnSave = _.bind(function () {
                if (typeof this.options.onSave === 'function')
                    this.options.onSave();
                this.removeModal();
            }, this);

        this.model.set('defaultView', this.options.defaultView);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.model.get('settings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;
                    setting.showGroupDescription = settingTemp.showGroupDescription;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    if (setting.view === PJQ.constants.addressBook.view.TRADES_COMPANY ||
                        setting.view === PJQ.constants.addressBook.view.TRADES_CONTACT) {

                        columns = setting.showGroupDescription ? ['groupDescription', 'groupCount', 'childCount'] : ['groupName', 'childCount'];
                    } else {
                        _.each(settingTemp.columns, _.bind(function (column) {
                            if (column.visible) {
                                if (columns.indexOf(column.columnData) === -1)
                                    columns.push(column.columnData);
                            } else {
                                if (columns.indexOf(column.columnData) !== -1)
                                    columns = _.filter(columns, _.bind(function (columnTemp) {
                                        return columnTemp != column.columnData;
                                    }, this));
                            }
                        }, this));
                    }

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.model.save(null, {
            success: _.bind(function () {
                if (forCompany) {
                    this.options.addressBookView.settings.fetch({
                        success: _.bind(function () {
                            fnOnSave();
                        }, this)
                    })
                } else {
                    this.model.set('defaultView', this.options.defaultView);
                    fnOnSave();
                }
            }, this)
        });
    }
});

PJQ.views.addressbook.AdvancedSearchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-advanced-search'),
        maxWidth: '70%',
        onSearch: _.noop,
        minWidth: 800
    },
    events: {
        'click .clear-search': 'clearSearch',
        'click .save-search': 'saveSearch',
        'click .delete-search': 'deleteSearch',
        'click .default-search': 'defaultSearch',
        'click .search': 'search',
        'keydown .phone': 'numbersOnly',
        'keydown .phone-ext': 'numbersOnly',
        'keydown .fax': 'numbersOnly',
        'keydown .cell': 'numbersOnly'
    },
    beforeModalCreated: function () {
        this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                this.coreFieldSettings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.renderData = {
            searches: this.options.settings.get('searches'),
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            fieldSettingsEnabled: this.options.fieldSettingsEnabled,
            coreFieldSettings: this.coreFieldSettings
        };
    },
    afterRender: function () {
        if (this.options.fieldSettingsEnabled && this.coreFieldSettings == null) {
            return;
        }

        this.savedSearchSelectPicker = new PJQ.inputs.Selectpicker({
            el: $('.saved-search'),
            noneSelectedText: 'New Search',
            defaultValue: null,
            onChange: _.bind(function () {
                let advancedSearch = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                    return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
                }, this))[0];
                this.$('.delete-search, .default-search').prop('disabled', false);
                this.setInputsFromSearch(advancedSearch);
            }, this)
        });

        if (_.size(this.options.settings.get('searches')) > 0)
            this.savedSearchSelectPicker.enable();

        this.companyBlacklistSelectPicker = new PJQ.inputs.Selectpicker({
            el: $('.company-is-blacklisted'),
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        if (this.checkFieldVisible('laborStatus')) {
            this.laborSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.labor-status'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        if (this.checkFieldVisible('classifications')) {
            this.classificationSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.minority-status'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        if (this.checkFieldVisible('sector')) {
            this.sectorSelectPicker = new PJQ.inputs.Selectpicker({
                el: $('.sector'),
                isMultiple: true,
                onChange: _.bind(function () {
                }, this)
            });
        }

        this.gradeSlider = new PJQ.Slider(this.$('.grade-slider'), {
            ticks: [0, 1, 2, 3, 4, 5],
            ticks_labels: [0, 1, 2, 3, 4, 5],
            value: [0, 5],
            onChange: _.bind(function (value) {
            }, this)
        });

        this.companyCustomFieldsCollapse = new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchCompanyCustomFieldsCollapseContainer')
        });

        PJQ.app.session.fetchCompanyCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function (customFields) {
            this.companyCustomFields = customFields;
            this.companyCustomFieldsForm = new PJQ.views.customFields.CustomFieldsSearchForm({
                el: this.$('.advanced-search-company-custom-fields'),
                isAdmin: true,
                collection: this.companyCustomFields,
                fieldValues: null
            });
        }, this));

        this.contactBlacklistSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-is-blacklisted'),
            isMultiple: false,
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        this.contactTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-type'),
            isMultiple: true,
            isIntChoices: true,
            defaultValue: null,
            onChange: _.bind(function () {
            }, this)
        });

        this.contactPrimarySelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contact-is-primary'),
            isMultiple: false,
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
            }, this)
        });

        this.locationSearchTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.location-search-type'),
            isIntChoices: true,
            defaultValue: 0,
            onChange: _.bind(function () {
                this.locationSearchTypeChanged();
            }, this)
        });
        this.locationSearchTypeChanged();

        this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.location-type'),
            isIntChoices: true,
            isMultiple: true,
            defaultValue: 1,
            onChange: _.bind(function (value) {
                let $radius = this.$('.search-radius-outer');
                if (value && value.indexOf(2) === -1) {
                    $radius.hide();
                } else {
                    $radius.show();
                }
            }, this)
        });

        this.searchRadiusSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.search-radius'),
            isIntChoices: true,
            defaultValue: 0
        });

        this.$('.cross-state-bounds').prop('checked', true);

        this.stateSelectPicker = new PJQ.inputs.StatePicker({
            el: this.$('select.state'),
            country: 'US',
            defaultValue: null,
            onChange: _.bind(function (value) {
            }, this)
        });

        this.countrySelectPicker = new PJQ.inputs.CountryPicker({
            el: this.$('select.country'),
            defaultValue: 'US',
            statePicker: this.stateSelectPicker,
            zipInput: this.$('.zip-2'),
            onChange: _.bind(function (value) {
            }, this)
        });

        this.groupCollapseContainer = new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchGroupsCollapseContainer')
        });

        this.groupSelector = new PJQ.views.groups.GroupSelector({
            el: this.$('.advanced-search-groups'),
            isShowNoGroup: true,
            onGroupSelected: _.bind(function () {
                //todo: trigger dirty
            }, this)
        });

        new PJQ.views.collapse.BaseCollapse({
            el: this.$('#advancedSearchContactCustomFieldsCollapseContainer')
        });

        PJQ.app.session.fetchContactCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function (customFields) {
            this.contactCustomFields = customFields;
            this.contactCustomFieldsForm = new PJQ.views.customFields.CustomFieldsSearchForm({
                el: this.$('.advanced-search-contact-custom-fields'),
                isAdmin: true,
                collection: this.contactCustomFields,
                fieldValues: null
            });
        }, this));

        if (this.options.advancedSearch)
            this.setInputsFromSearch(this.options.advancedSearch);
        else {
            _.each(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                if (savedSearch.isDefault)
                    this.setInputsFromSearch(savedSearch);
            }, this))
        }
    },
    locationSearchTypeChanged: function () {
        if (this.locationSearchTypeSelectPicker.getValue() === 0) {
            this.$('.location-search-zip-radius').removeClass('hidden');
            this.$('.location-search-city-state-zip').addClass('hidden');
        } else {
            this.$('.location-search-zip-radius').addClass('hidden');
            this.$('.location-search-city-state-zip').removeClass('hidden');
        }
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false;
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisibleContact') || fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    setInputsFromSearch: function (advancedSearch) {
        let search = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === advancedSearch.searchId;
        }, this));

        if (_.size(search) > 0) {
            this.savedSearchSelectPicker.setValue(advancedSearch.searchId);
            this.$('.delete-search, .default-search').prop('disabled', false);
            this.$('.default-search').text(advancedSearch.isDefault ? 'Unset Default' : 'Set Default');
        } else {
            this.savedSearchSelectPicker.setValue(null);
            this.$('.delete-search, .default-search').prop('disabled', true);
            this.$('.default-search').text('Set Default');
        }

        this.$('input.search-name').val(advancedSearch.searchName);
        this.$('input.company-name').val(advancedSearch.companyName);
        this.companyBlacklistSelectPicker.setValue(advancedSearch.isCompanyBlacklisted ? 1 : 0);

        if (this.laborSelectPicker != null) {
            let laborStatus = [];
            if (advancedSearch.isUnion)
                laborStatus.push('isUnion');
            if (advancedSearch.isNonUnion)
                laborStatus.push('isNonUnion');
            if (advancedSearch.isPrevailingWage)
                laborStatus.push('isPrevailingWage');
            this.laborSelectPicker.setValue(laborStatus);
        }

        if (this.classificationSelectPicker != null) {
            let classification = [];
            if (advancedSearch.isDBE)
                classification.push('isDBE');
            if (advancedSearch.isDVBE)
                classification.push('isDVBE');
            if (advancedSearch.isMBE)
                classification.push('isMBE');
            if (advancedSearch.isSBE)
                classification.push('isSBE');
            if (advancedSearch.isSDVBE)
                classification.push('isSDVBE');
            if (advancedSearch.isWBE)
                classification.push('isWBE');
            this.classificationSelectPicker.setValue(classification);
        }

        if (this.sectorSelectPicker != null) {
            let sector = [];
            if (advancedSearch.isPrivateSector)
                sector.push('isPrivateSector');
            if (advancedSearch.isPublicSector)
                sector.push('isPublicSector');
            this.sectorSelectPicker.setValue(sector);
        }

        this.gradeSlider.setValue([advancedSearch.minGradeAverage, advancedSearch.maxGradeAverage]);

        this.companyCustomFieldsForm.setValues(advancedSearch.companyCustomFields);
        if (_.size(advancedSearch.companyCustomFields) > 0)
            this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('show');

        this.$('input.contact-name').val(advancedSearch.contactName);
        this.$('input.contact-title').val(advancedSearch.contactTitle);
        this.contactBlacklistSelectPicker.setValue(advancedSearch.isBlacklisted ? 1 : 0);

        this.$('input.phone').val(advancedSearch.phone);
        this.$('input.phone-ext').val(advancedSearch.phoneExtension);
        this.$('input.fax').val(advancedSearch.fax);
        this.$('input.cell').val(advancedSearch.cell);
        this.contactTypeSelectPicker.setValue(advancedSearch.userTypes);
        this.contactPrimarySelectPicker.setValue(advancedSearch.isPrimaryOnly ? 1 : 0);

        this.$('input.email').val(advancedSearch.email);

        if (advancedSearch.locationType > 0) {
            this.locationSearchTypeSelectPicker.setValue(0);
            this.$('.location-search-zip-radius').removeClass('hidden');
            this.$('.location-search-city-state-zip').addClass('hidden');

            let locationFilter;
            if (advancedSearch.locationType === 3) {
                locationFilter = [1, 2];
            } else {
                locationFilter = [advancedSearch.locationType];
            }
            this.locationTypeSelectPicker.setValue(locationFilter);
            this.locationTypeSelectPicker.options.onChange(locationFilter);

            this.$('input.zip-1').val(advancedSearch.originzip);
            this.searchRadiusSelectPicker.setValue(advancedSearch.radius);
            this.$('.cross-state-bounds').prop('checked', advancedSearch.isCrossStateBoundaries);
            this.$('input.city').val('');
            this.stateSelectPicker.setValue(null);
            this.$('input.zip-2').val('');
            this.countrySelectPicker.setValue('US');
        } else {
            this.locationSearchTypeSelectPicker.setValue(1);
            this.$('.location-search-zip-radius').addClass('hidden');
            this.$('.location-search-city-state-zip').removeClass('hidden');

            let locationFilter = [0];
            this.locationTypeSelectPicker.setValue(locationFilter);
            this.locationTypeSelectPicker.options.onChange(locationFilter);

            this.locationTypeSelectPicker.options.onChange();
            this.$('input.zip-1').val('');
            this.searchRadiusSelectPicker.setValue(0);
            this.$('.cross-state-bounds').prop('checked', true);
            this.$('input.city').val(advancedSearch.city);
            this.stateSelectPicker.setValue(advancedSearch.state);
            this.$('input.zip-2').val(advancedSearch.zip);
            this.countrySelectPicker.setValue(advancedSearch.country);
        }

        if (this.groupSelector.collection)
            this.groupSelector.selectAll(false);
        this.groupSelector.selectGroups(advancedSearch.groups);
        this.groupSelector.expandSelectedParents();
        if (_.size(advancedSearch.groups) > 0)
            this.$('#advancedSearchGroupsCollapse').collapse('show');

        this.contactCustomFieldsForm.setValues(advancedSearch.customFields);
        if (_.size(advancedSearch.customFields) > 0)
            this.$('#advancedSearchContactCustomFieldsCollapse').collapse('show');
    },
    createSearchFromInputs: function () {
        let advancedSearch = this.savedSearchSelectPicker.getValue() ? _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
        }, this))[0] : {};

        advancedSearch.searchId = this.savedSearchSelectPicker.getValue() ? this.savedSearchSelectPicker.getValue() : PJQ.helpers.guid();
        advancedSearch.searchName = this.$('input.search-name').val().trim();
        advancedSearch.companyName = this.$('input.company-name').val().trim();
        advancedSearch.isCompanyBlacklisted = this.companyBlacklistSelectPicker.getValue() === 1;

        if (this.laborSelectPicker != null) {
            let laborValues = this.laborSelectPicker.getValue() || [];
            advancedSearch.isUnion = laborValues.indexOf('isUnion') !== -1;
            advancedSearch.isNonUnion = laborValues.indexOf('isNonUnion') !== -1;
            advancedSearch.isPrevailingWage = laborValues.indexOf('isPrevailingWage') !== -1;
        }

        if (this.classificationSelectPicker != null) {
            let classificationValues = this.classificationSelectPicker.getValue() || [];
            advancedSearch.isDBE = classificationValues.indexOf('isDBE') !== -1;
            advancedSearch.isDVBE = classificationValues.indexOf('isDVBE') !== -1;
            advancedSearch.isMBE = classificationValues.indexOf('isMBE') !== -1;
            advancedSearch.isSBE = classificationValues.indexOf('isSBE') !== -1;
            advancedSearch.isSDVBE = classificationValues.indexOf('isSDVBE') !== -1;
            advancedSearch.isWBE = classificationValues.indexOf('isWBE') !== -1;
        }

        if (this.sectorSelectPicker != null) {
            let sectorValue = this.sectorSelectPicker.getValue() || [];
            advancedSearch.isPrivateSector = sectorValue.indexOf('isPrivateSector') !== -1;
            advancedSearch.isPublicSector = sectorValue.indexOf('isPublicSector') !== -1;
        }

        advancedSearch.minGradeAverage = this.gradeSlider.getValue()[0];
        advancedSearch.maxGradeAverage = this.gradeSlider.getValue()[1];

        advancedSearch.companyCustomFields = this.companyCustomFieldsForm.getValues();

        advancedSearch.contactName = this.$('input.contact-name').val().trim();
        advancedSearch.contactTitle = this.$('input.contact-title').val().trim();
        advancedSearch.isBlacklisted = this.contactBlacklistSelectPicker.getValue() === 1;

        advancedSearch.phone = this.$('input.phone').val().trim();
        advancedSearch.phoneExtension = this.$('input.phone-ext').val().trim();
        advancedSearch.fax = this.$('input.fax').val().trim();
        advancedSearch.cell = this.$('input.cell').val().trim();
        advancedSearch.userTypes = this.contactTypeSelectPicker.getValue() || [];
        advancedSearch.isPrimaryOnly = this.contactPrimarySelectPicker.getValue() === 1;

        advancedSearch.email = this.$('input.email').val().trim();

        if (this.locationSearchTypeSelectPicker.getValue() === 0) {
            let loc = this.locationTypeSelectPicker.getValue() || [],
                isWorkAreas = loc.indexOf(1) !== -1,
                isOffice = loc.indexOf(2) !== -1,
                locationFilter;
            if (isWorkAreas && isOffice) {
                locationFilter = 3;
            } else if (isWorkAreas) {
                locationFilter = 1;
            } else if (isOffice) {
                locationFilter = 2;
            }
            advancedSearch.locationType = locationFilter;
            advancedSearch.originzip = this.$('input.zip-1').val().trim();
            advancedSearch.radius = this.searchRadiusSelectPicker.getValue();
            advancedSearch.isCrossStateBoundaries = this.$('.cross-state-bounds').prop('checked');
            advancedSearch.city = '';
            advancedSearch.state = '';
            advancedSearch.zip = '';
            advancedSearch.country = '';
        } else {
            advancedSearch.locationType = 0;
            advancedSearch.originzip = '';
            advancedSearch.radius = 0;
            advancedSearch.isCrossStateBoundaries = true;
            advancedSearch.city = this.$('input.city').val().trim();
            advancedSearch.state = this.stateSelectPicker.getValue();
            advancedSearch.zip = this.$('input.zip-2').val().trim();
            advancedSearch.country = this.countrySelectPicker.getValue();
        }

        advancedSearch.groups = _.map(this.groupSelector.getGroupsData().selected, function (group) {
            return group.get('groupId');
        });
        advancedSearch.regions = [];

        advancedSearch.customFields = this.contactCustomFieldsForm.getValues();

        return advancedSearch;
    },
    validate: function (save) {
        let isValid = true;

        if (!this.companyCustomFieldsForm.validateSearch()) {
            isValid = false;
            this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('show');
        }

        if (!this.contactCustomFieldsForm.validateSearch()) {
            isValid = false;
            this.$('#advancedSearchContactCustomFieldsCollapse').collapse('show');
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('input.search-name'), true);
        if (save && _.size(this.$('input.search-name').val().trim()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('input.search-name'), false);
        }

        return isValid;
    },
    saveSearch: function () {
        this.search(null, true);
    },
    search: function (e, save) {
        let advancedSearch = this.createSearchFromInputs(), callback = _.bind(function () {
            this.options.onSearch(advancedSearch);
            this.removeModal();
        }, this);

        if (!this.validate(save))
            return;

        if (save) {
            if (this.savedSearchSelectPicker.getValue()) {
                _.each(this.options.settings.get('searches'), _.bind(function (search) {
                    if (search.searchId === advancedSearch.searchId)
                        search = advancedSearch;
                }, this));
            } else {
                this.options.settings.get('searches').push(advancedSearch);
            }
            this.options.settings.save(null, {
                success: _.bind(function () {
                    callback();
                }, this)
            });
        } else {
            callback();
        }
    },
    clearSearch: function () {
        this.options.advancedSearch = null;
        this.$('.delete-search, .default-search').prop('disabled', true);
        this.$('.default-search').text('Set Default');

        this.savedSearchSelectPicker.setValue(null);
        this.$('.search-name').val('');

        this.$('.company-name').val('');
        this.companyBlacklistSelectPicker.setValue(0);

        if (this.laborSelectPicker != null) {
            this.laborSelectPicker.setValue(null);
        }
        if (this.classificationSelectPicker != null) {
            this.classificationSelectPicker.setValue(null);
        }
        if (this.sectorSelectPicker != null) {
            this.sectorSelectPicker.setValue(null);
        }

        this.gradeSlider.setValue([0, 5]);

        this.companyCustomFieldsForm.clearFieldValues();
        this.$('#advancedSearchCompanyCustomFieldsCollapse').collapse('hide');

        this.$('.contact-name,.phone,.phone-ext,.fax,.cell,.email').val('');
        this.contactBlacklistSelectPicker.setValue(0);

        this.groupSelector.selectAll(false);
        this.$('#advancedSearchGroupsCollapse').collapse('hide');

        this.contactCustomFieldsForm.clearFieldValues();
        this.$('#advancedSearchContactCustomFieldsCollapse').collapse('hide');

        this.locationSearchTypeSelectPicker.setValue(0);
        this.locationTypeSelectPicker.setValue(1);
        this.$('.zip-1, .zip-2, .city').val('');
        this.countrySelectPicker.setValue('US');
        this.stateSelectPicker.setValue(null);
        this.searchRadiusSelectPicker.setValue(0);
        this.$('.cross-state-bounds').prop('checked', true);
        this.locationSearchTypeChanged();

        this.$('.company-name').focus();
    },
    deleteSearch: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this search?",
            onDelete: _.bind(function () {
                this.options.settings.set('searches', _.filter(this.options.settings.get('searches'), _.bind(function (search) {
                    return (search.searchId !== this.savedSearchSelectPicker.getValue());
                }, this)));

                this.options.settings.save(null, {
                    success: _.bind(function () {
                        this.$('select.saved-search option[value="' + this.savedSearchSelectPicker.getValue() + '"]').remove();
                        this.savedSearchSelectPicker.setValue(null);
                        this.savedSearchSelectPicker.refresh();
                        this.clearSearch();
                    }, this)
                });
            }, this)
        });
    },
    defaultSearch: function () {
        // find current search
        let search = _.filter(this.options.settings.get('searches'), _.bind(function (savedSearch) {
            return savedSearch.searchId === this.savedSearchSelectPicker.getValue();
        }, this))[0];

        if (!this.validate(true))
            return;

        // toggle search state / button label
        if (search.isDefault) {
            search.isDefault = false;
        } else {
            _.each(this.options.settings.get('searches'), _.bind(function (savedSearch) {
                savedSearch.isDefault = (savedSearch.searchId === search.searchId);
            }, this));
        }

        // save
        this.options.settings.save(null, {
            success: _.bind(function () {
                this.$('.default-search').text(search.isDefault ? 'Unset Default' : 'Set Default');
                PJQ.notifications.notify.successNotify({
                    message: 'Default search ' + (search.isDefault ? 'saved' : 'cleared') + ' successfully'
                });
            }, this)
        });
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    }
});

PJQ.views.addressbook.ProqualRequestModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request'),
        minWidth: '800px',
        request: {
            screeningPackageId: null,
            isBillSender: null,
            processorNotes: '',
            uploaderGuid: PJQ.helpers.guid(),
            attachments: new PJQ.collections.files.Files(),
            selectedContacts: []
        },
        onAddParticipants: _.noop,
        onSend: _.noop
    },
    events: {
        'click .add-contacts': 'addContacts',
        'click .request-close': 'close',
        'click .request-preview': 'previewRequest',
        'click .request-viewitems': 'viewPackageItems',
        'click .request-send': 'sendRequest',
        'change .proqual-notes': 'notesChanged'
    },
    beforeModalCreated: function () {
        this.options.isProqual = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER);
        this.options.isSingleContact = this.options.contactId > 0;
        if (this.options.isSingleContact) {
            this.options.isSingleContact = true;
            this.options.request.selectedContacts = [this.options.contactId];
        }

        PJQ.app.session.fetchScreeningSettings(_.bind(function (settings) {
            this.settings = settings;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            selectedContacts: this.options.request.selectedContacts,
            settings: this.settings.attributes,
            isProqual: this.options.isProqual,
            isSingleContact: this.options.isSingleContact,
        };
    },
    setButtonStates: function () {
        this.$('.request-preview, .request-viewitems').prop('disabled', !this.packageSelectPicker.getValue());
        this.$('.request-send').prop('disabled', !this.packageSelectPicker.getValue() || (this.paymentSelectPicker != null && !this.paymentSelectPicker.getValue()) || (_.size(this.options.request.selectedContacts) === 0 && _.size(this.options.request.attachments) === 0));
    },
    afterRender: function () {
        if (this.settings == null)
            return;

        this.packageSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.proqual-package'),
            noneSelectedText: 'Select Package',
            isIntChoices: true,
            defaultValue: this.options.request.screeningPackageId,
            onChange: _.bind(function (value) {
                this.options.request.screeningPackageId = value;
                this.setButtonStates();
            }, this)
        });

        if (this.options.isProqual) {
            this.$('.proqual-payment').prop('disabled', this.settings.get('isPaymentMethodReadOnly'));
            if (this.options.request.isBillSender == null && this.settings.get('defaultPaymentMethod') != null) {
                this.options.request.isBillSender = this.settings.get('defaultPaymentMethod').toLowerCase() === 'sender';
            }

            this.paymentSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.proqual-payment'),
                noneSelectedText: 'Select Payment Type',
                isIntChoices: true,
                defaultValue: this.options.request.isBillSender !== undefined ? (this.options.request.isBillSender ? 1 : 2) : null,
                onChange: _.bind(function (value) {
                    if (value !== null)
                        this.options.request.isBillSender = (value === 1);

                    this.setButtonStates();
                }, this)
            });

            this.$('.proqual-notes').val(this.options.request.processorNotes ? this.options.request.processorNotes : '');

            if (!this.options.isSingleContact) {
                this.uploader = new PJQ.views.files.FileUploaderGrid({
                    el: this.$('.request-uploader'),
                    collection: this.options.request.attachments,
                    uuid: this.options.request.uploaderGuid,
                    onDelete: _.bind(function (attachment, callback) {
                        attachment.destroy();
                        callback();
                        this.setButtonStates();
                    }, this),
                    onSuccess: _.bind(function () {
                        this.setButtonStates();
                    }, this),
                });
            }
        }

        this.setButtonStates();
    },
    notesChanged: function () {
        this.options.request.processorNotes = this.$('.proqual-notes').val();
    },
    addContacts: function () {
        if (this.uploader) {
            this.options.request.attachments = this.uploader.collection;
        }
        this.options.onAddParticipants(this.options.request);
        this.removeModal();
    },
    previewRequest: function () {
        new PJQ.views.addressbook.ProqualRequestPreviewModal({
            screeningPackageId: this.packageSelectPicker.getValue()
        });
    },
    viewPackageItems: function () {
        new PJQ.views.addressbook.ProqualRequestViewItemsModal({
            screeningPackage: _.filter(this.settings.get('packages'), _.bind(function (screeningPackage) {
                return screeningPackage.screeningPackageId === this.packageSelectPicker.getValue();
            }, this))[0]
        });
    },
    sendRequest: function () {
        let confirmText;
        if (this.options.isProqual) {
            confirmText = "Are you sure you want to " + (this.paymentSelectPicker.getValue() === 1 ? "place this order and " : "") + "send these requests?";
        } else {
            confirmText = "Are you sure you want to send this request?";
        }
        let callback = _.bind(function () {
            new PJQ.views.modals.YesNo({
                header: "Confirm Request",
                body: confirmText,
                onYes: _.bind(function () {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'addressbook'
                            },
                            {
                                endpoint: 'proqual'
                            },
                            {
                                endpoint: 'request'
                            }
                        ]),
                        data: {
                            screeningPackageId: this.packageSelectPicker.getValue(),
                            isBillSender: this.options.request.isBillSender,
                            notes: this.options.request.processorNotes,
                            attachments: this.options.request.attachments.models,
                            contacts: this.options.request.selectedContacts
                        }
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Your qualification request is now queued for processing.'
                        });
                        this.options.onSend();
                        this.removeModal();
                    }, this)).fail(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong.'
                        });
                    });
                }, this)
            });
        }, this);

        if (_.size(this.options.request.selectedContacts) > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'addressbook'
                    },
                    {
                        endpoint: 'proqual'
                    },
                    {
                        endpoint: 'request'
                    },
                    {
                        endpoint: 'check'
                    }
                ]),
                data: {
                    screeningPackageId: this.options.request.screeningPackageId,
                    contacts: this.options.request.selectedContacts
                }
            }).post().done(_.bind(function (data) {
                if (_.size(data.contacts) > 0) {
                    new PJQ.views.addressbook.ProqualRequestErrorModal({
                        contacts: data.contacts,
                        selectedContacts: this.options.request.selectedContacts,
                        onContinue: _.bind(function () {
                            callback();
                        }, this)
                    });
                } else
                    callback();
            }, this)).fail(function () {
                PJQ.notifications.notify.errorNotify({
                    message: 'Something went wrong.'
                });
            });
        } else {
            callback();
        }
    }
});

PJQ.views.addressbook.ProqualRequestViewItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Items'),
        minWidth: '60%',
        screeningPackage: null
    },
    beforeRender: function () {
        this.renderData = {
            items: this.options.screeningPackage.packageItems
        };
    }
});

PJQ.views.addressbook.ProqualRequestPreviewModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Preview'),
        minWidth: '60%',
        screeningPackageId: 0
    },
    events: {
        'click .preview-export': 'export'
    },
    beforeModalCreated: function () {
        this.isFetched = false;

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'proqual'
            },
            {
                endpoint: 'preview'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                screeningPackageId: this.options.screeningPackageId,
                isExport: false
            }
        }).post().done(_.bind(function (data) {
            this.isFetched = true;
            this.previewHTML = data.html;
            this.render();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    },
    afterRender: function () {
        this.$('.message-body').html(this.previewHTML);
    },
    export: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'proqual'
            },
            {
                endpoint: 'preview'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                screeningPackageId: this.options.screeningPackageId,
                isExport: true
            }
        }).post().done(_.bind(function (data) {
            PJQ.files.downloadFile(data.url, {isEndpoint: false});
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });
    }
});

PJQ.views.addressbook.ProqualRequestErrorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Proqual-Request-Error-List'),
        minWidth: '90%',
        contacts: null,
        selectedContacts: null,
        onContinue: _.noop
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-continue': 'continue',
        'click .export': 'export'
    },
    beforeRender: function () {
        this.renderData = {
            invalidContacts: _.size(this.options.contacts),
            validContacts: _.size(this.options.selectedContacts) - _.size(this.options.contacts)
        };
    },
    afterRender: function () {
        new PJQ.views.dataTables.DataTable({
            el: this.$('.contact-errors'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.options.contacts,
            dom: 't',
            order: [],
            columns: [
                {
                    "data": "companyName",
                    "title": "Company",
                    "orderable": false
                },
                {
                    "data": "contactName",
                    "title": "Contact",
                    "orderable": false
                },
                {
                    "data": "phone",
                    "title": "Phone",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                            phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

                        if (row.phone !== '')
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                        html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                        html += '</div>';
                        return html;
                    }, this)
                },
                {
                    "data": "email",
                    "title": "Email",
                    "orderable": false
                },
                {
                    "data": "reason",
                    "title": "Reason",
                    "orderable": false
                }
            ]
        });

    },
    continue: function () {
        if (typeof this.options.onContinue === 'function')
            this.options.onContinue();

        this.removeModal();
    },
    export: function () {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    }
});

PJQ.views.addressbook.MergeRequestModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Merge-Request'),
        minWidth: '70%',
        data: null,
        addressBookView: null,
        onMerge: _.noop
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-merge-confirm': 'mergeContacts'
    },
    beforeModalCreated: function () {
        this.companies = [];
        this.contacts = [];

        _.each(this.options.data, _.bind(function (item) {

            if (!item.company.companyName) {
                item.company.companyName = 'Company ' + item.company.contactId.toString();
                _.each(item.contacts, function (contact) {
                    contact.companyName = item.company.companyName;
                });
            }

            this.companies.push(item.company);
            $.merge(this.contacts, item.contacts);
        }, this));
    },
    beforeRender: function () {
        this.renderData = {
            companies: this.companies
        };
    },
    afterRender: function () {
        this.destinationSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.destination-company'),
            defaultValue: null,
            onChange: _.bind(function (value) {
                this.$('.btn-merge-confirm').prop('disabled', !value);
            }, this)
        });

        new PJQ.views.dataTables.DataTable({
            el: this.$('.merge-data'),
            pageLength: 999999,
            isHideSearch: true,
            data: this.contacts,
            dom: 't',
            order: [],
            columns: [
                {
                    "data": "companyName",
                    "title": "Company",
                    "orderable": false
                },
                {
                    "data": "contactName",
                    "title": "Contact",
                    "orderable": false
                },
                {
                    "data": "phone",
                    "title": "Phone",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                            phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

                        if (row.phone !== '')
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                        html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                        html += '</div>';
                        return html;
                    }, this)
                },
                {
                    "data": "email",
                    "title": "Email",
                    "orderable": false
                }
            ]
        });

    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    mergeContacts: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'addressbook',
            },
            {
                endpoint: 'merge'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                destinationContactId: this.destinationSelectPicker.getValue(),
                contacts: this.options.addressBookView.selectedContactsAll
            }
        }).post().done(_.bind(function () {
            loader.remove();
            PJQ.notifications.notify.successNotify({
                message: 'Contacts merged successfully.'
            });

            let companyIds = _.reduce(this.companies, (result, company) => {
                if (company.contactId !== this.destinationSelectPicker.getValue()) {
                    result.push(company.contactId);
                }
                return result;
            }, []);

            PJQ.app.session.fetchERPIntegration((erp) => {
                if (!erp) {
                    return;
                }

                _.each(companyIds, (companyId) => {
                    let company = new PJQ.models.contacts.Company({
                        id: companyId
                    });

                    let processCompany = () => {
                        if (company?.get('externalObject')) {
                            if (_.size(company.contacts.models) !== 0) {
                                return;
                            }
                            company.unlinkERP();
                        }
                    };

                    if (!company.isNew() && !company.isFetched) {
                        company.fetch({
                            success: () => {
                                company.fetchERPObject(processCompany);
                            }
                        });
                    } else {
                        company.fetchERPObject(processCompany);
                    }
                });
            });


            if (typeof this.options.onMerge === 'function')
                this.options.onMerge();

            this.removeModal();
        }, this)).fail(function () {
            loader.remove();
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

    }
});

PJQ.views.addressbook.QualificationsReportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Qualifications-Report'),
        minWidth: '500px'
    },
    events: {
        'click .btn-continue': 'export',
        'keyup .email': 'emailChanged'
    },
    afterRender: function () {
        new PJQ.Alert(this.$('.email-alert'), {
            text: 'Please enter your email address, and the report will be sent to you when it is ready.'
        });

        this.$('.email').val(PJQ.app.session.user.get('email'));
        this.emailChanged();
    },
    emailChanged: function () {
        this.$('.btn-continue').prop('disabled', this.$('.email').val().indexOf('@') <= 0);
    },
    export: function () {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'reports',
            },
            {
                endpoint: 'qualification_screenings'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                options: [
                    {
                        id: _.unique(),
                        type: 'STRING',
                        name: 'email',
                        isRequired: true,
                        defaultValue: {
                            email: this.$('.email').val().trim()
                        },
                        value: this.$('.email').val().trim()
                    }
                ]
            }
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Report processing - you will receive an email with the report attached when it is ready.'
            });

            this.removeModal();
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

    }
});

PJQ.views.contacts.EditContactView = PJQ.views.contacts.BaseEditContactView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'edit-company-contact'),
        canEdit: true,
        alert: null
    }
});

PJQ.views.addressbook.EditCompanyView = PJQ.views.contacts.BaseEditContactView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-company'),
        subTemplates: {
            contact: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-company-contact')
        },
        maxWidth: 1400,
        canEdit: true,
        isShowCloseButton: true,
        onDelete: _.noop,
        onCancel: _.noop,
        onSave: _.noop,
        onSaveContact: _.noop,
        isAdmin: true,
        alert: null
    },
    events: {
        "change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
        "keyup .contact-edit-phone-ext": "numbersOnly",
        "keydown .contact-edit-phone-ext": "numbersOnly",
        "click .contact-edit-add": "addNew",
        'click .btn-add-contact': 'addNewContactClicked',
        'click .btn-delete-contact': 'deleteContactClicked',
        'click .btn-copy-contact': 'copyContactClicked',
        'click .btn-set-primary-contact': 'setPrimaryClicked',
        'click .btn-edit-permissions': 'editPermissions',
        'click .btn-copy-phone': 'copyPhone',
        "click .btn-unlock-user": "unlockUser",
        'click .btn-unlink-user': 'unlinkContactUser',
        'click .btn-send-user-reg': 'sendSignUp',
        "click .btn-send-password-reset": "sendPasswordReset",
        "click .btn-company-active": "isActiveClicked",
        "click .btn-contact-active": "checkIsPrimary",
        "click .btn-show-groups": "showRowGroups",
        "click .btn-edit-contact": "contactSwitchedClicked",
        "click .btn-contact-permissions": "editContactPermissions",
        "click .btn-mirror-trades": "mirrorTrades",
        "click .btn-screening-request-company": "newScreeningRequest",
        "click .btn-prequal-audit-log": "viewPrequalAuditLog"
    },
    beforeFirstRender: function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.company = this.options.company;

        let fieldUserId = PJQ.app.session.project != null ? PJQ.app.session.project.get('masterUserId') : null,
            fetchERP = (callback) => {
                PJQ.app.session.fetchERPIntegration((erp) => {
                    this.erpIntegration = erp;
                    if (this.erpIntegration != null) {
                        this.company.fetchERPObject(() => {
                            callback();
                        });
                    } else {
                        callback();
                    }
                });
            },
            fnFetch = () => {
                if (this.company == null) {
                    this.company = new PJQ.models.contacts.Company({
                        id: this.options.contactCompanyId ? this.options.contactCompanyId : this.options.contactId
                    });
                }

                if (!this.company.isNew() && !this.company.isFetched) {
                    this.company.fetch({
                        success: () => {
                            fetchERP(() => {
                                this.render();
                            });
                        }
                    });
                } else {
                    fetchERP(() => {
                        this.render();
                    });
                }

                PJQ.app.session.fetchCompanyCustomFields(fieldUserId, _.bind(function (customFields) {
                    this.companyCustomFields = customFields;
                    if (this.isRendered) {
                        this.renderCompanyCustomFields();
                    }
                }, this));
                PJQ.app.session.fetchContactCustomFields(fieldUserId, _.bind(function (customFields) {
                    this.contactCustomFields = customFields;
                    if (this.isRendered) {
                        this.renderContactCustomFields();
                    }
                }, this));
            };

        this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
        if (this.options.fieldSettingsEnabled) {
            PJQ.app.session.fetchContactFieldSettings(fieldUserId, _.bind(function (settings) {
                this.coreFieldSettings = settings;
                fnFetch();
            }, this));
        } else {
            fnFetch();
        }
    },
    beforeRender: function () {
        return PJQ.views.contacts.BaseEditContactView.prototype.beforeRender.call(this);
    },
    renderData: function () {
        return {
            company: this.company,
            userTypes: PJQ.app.session.userTypes.getByIsCompany(false),
            prevailingWageLabel: this.options.prevailingWageLabel,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            enablePermissions: this.options.enablePermissions,
            canEdit: this.options.canEdit,
            canEditCustomFields: this.options.canEditCustomFields,
            isAdmin: this.options.isAdmin,
            showScreenings: this.options.showScreenings,
            showCompanyCustomFields: this.companyCustomFields != null && this.companyCustomFields.length > 0,
            canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
        };
    },
    afterRender: function () {
        if (this.company != null && (this.company.isNew() || this.company.isFetched)) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.company-edit-active'),
                noneSelectedText: 'Select Value',
                defaultValue: this.company.get('isBlacklisted') ? 'inactive' : 'active',
                onChange: _.bind(function (value) {
                    this.company.set('isBlacklisted', value === 'inactive');
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.select-approval-level'),
                noneSelectedText: 'Select Value',
                // defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : null,
                onChange: _.bind(function (value) {

                }, this)
            });

            this.renderERP();
            this.renderGrade(this.company);
            this.renderLaborStatus(this.model);
            this.renderSector(this.model);
            this.renderMinority(this.model);

            new PJQ.views.collapse.BaseCollapse({
                el: this.$('#companyInfoCollapseContainer'),
                onShown: _.bind(function (id) {
                    switch (id) {
                        case 'companyAttachmentsCollapse':
                            this.renderCompanyAttachments();
                            break;
                        case 'prequalCollapse':
                            this.renderPrequal();
                            break;
                        case 'screeningCollapse':
                            this.renderScreenings();
                            break;
                    }
                }, this)
            });

            this.renderCompanyGroups();
            this.setContextContact();
            this.renderContactsTable();
        } else {
            new PJQ.Loader(this.$('.modal-body'));
        }

        if (!this.model) {
            this.addNewContact();
        }
    },
    editContactPermissions: function (e) {
        let target = $(e.currentTarget),
            row = this.contactListTable.getRow(target.closest('tr')),
            contact = row.data();
        new PJQ.views.permissions.PermissionsEditorModal({
            model: contact
        });
    },
    viewBidHistory: function () {
        this.bidHistory = new PJQ.views.projects.ProjectParticipantHistoryModal({
            contactId: this.model.get('contactId'),
            onGoToProject: _.bind(function () {
                if (this.options.closeModal) {
                    this.options.closeModal();
                }
            }, this)
        });
        this.bidHistory.renderHistory('overall')
    },
    contactSwitched: function (contactId = null) {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Save current selected contact?",
                body: "You have made changes to the current selected contact.  Would you like to save this contact before switching contacts?",
                onSave: _.bind(function () {
                    this.saveCompanyContact(false, _.bind(function () {
                        this.setContextContact(contactId);
                    }, this));
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    this.setContextContact(contactId);
                }, this)
            })
        } else {
            this.setContextContact(contactId);
        }
    },
    setContextContact: function (contactId = null, existingModel) {
        if (this.model != null && this.model.id === this.company.get('contactId')) {
            this.model = null;
        }
        let contextId = this.options.contactId;
        if (contactId > 0) {
            contextId = contactId;
        }
        if (contextId > 0 && contextId !== this.company.get('contactId') && this.model.id !== contextId) {
            this.model = this.company.contacts.get(contextId);
        }

        if (this.model == null) {
            this.model = this.company.contacts.findWhere({isPrimary: true});
            if (this.model == null && !this.company.isNew()) {
                this.model = this.company.contacts.models[0];
            } else if (existingModel) {
                this.model = existingModel;
            } else if (this.model == null && this.company.isNew()) {
                let userTypes = PJQ.app.session.userTypes.getByIsCompany(false),
                    defaultUserType = _.find(userTypes, function (ut) {
                        return ut.get('isDefault');
                    });
                if (defaultUserType == null && _.size(userTypes) > 0) {
                    defaultUserType = userTypes[0];
                }

                this.model = new PJQ.models.contacts.Contact({
                    contactName: "",
                    userTypeId: this.company.get('userTypeId') ? this.company.get('userTypeId') : defaultUserType.id,
                    title: "",
                    address1: "",
                    address2: "",
                    isPrimary: true,
                    city: "",
                    zip: "",
                    state: "",
                    country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US',
                    phone: "",
                    cell: "",
                    fax: "",
                    email: "",
                    notes: "",
                    isAutoSelectDisabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DEFAULT_AUTO_SELECT_DISABLED)
                });
                this.company.contacts.add(this.model);
            }
        }

        this.options.contactId = this.model ? this.model.id : null;
        let fnRender = _.bind(function () {
            this.renderContact();
            if (this.contactListTable) {
                this.contactListTable.render();
            }
        }, this)
        if (this.model && !this.model.isFetched && this.model.id > 0) {
            this.model.fetch({
                success: _.bind(function () {
                    fnRender();
                }, this)
            });
        } else {
            fnRender();
        }
    },
    renderGrade: function (company) {
        new PJQ.inputs.StarRating({
            el: this.$('.company-rating'),
            rating: company.get('gradeAverage'),
            isReadOnly: true
        });
    },
    renderContact: function () {
        this.renderSubTemplate(false, this.options.subTemplates.contact, this.$('.contact-outer'), this.contactRenderData(), _.bind(function () {
            if (this.model.get('isApprovalRequired') && !PJQ.app.session.hasPermission('contacts.canApprove')) {
                $('.contact-edit-save').hide();
                $('.contact-edit-delete').hide();
            } else {
                $('.contact-edit-save').text(this.model.get('isApprovalRequired') ? "Approve" : "Save");
            }

            return PJQ.views.contacts.BaseEditContactView.prototype.renderContact.call(this);
        }, this));
    },
    contactRenderData: function () {
        return {
            company: this.company,
            model: this.model,
            userTypes: PJQ.app.session.userTypes.getByIsCompany(false),
            showNotes: this.options.showNotes !== false,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            isGroupsRequired: this.options.isGroupsRequired === true,
            canEdit: this.options.canEdit,
            isUserTypeRequired: true,
            canEditCustomFields: this.options.canEditCustomFields,
            showContactCustomFields: this.contactCustomFields != null && this.contactCustomFields.length > 0,
            canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
        };
    },
    groupsChanged: function (data) {
        this.model.groups.reset(data.selected);
        this.renderCompanyGroups();
    },
    renderCompanyGroups: function () {
        this.groupViewer = new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.company-groups'),
            isShowAddButton: false,
            selectedGroups: this.company.getGroups(),
            isReadOnly: true,
            limitGroups: true
        });
    },
    renderCompanyAttachments: function () {
        if (!PJQ.app.session.hasPermission('contacts.canViewAttachments')) {
            return;
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.company-documents'),
            collection: this.company.attachments,
            // canUpload: this.model.get('status') !== PJQ.constants.rfi.statuses.CLOSED,
            // canDelete: this.options.canEdit && this.options.isAdmin,
            previewImageDimension: 150,
            canUpload: this.options.canEdit,
            canDownloadAll: true,
            onSuccess: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    renderContactsTable: function () {
        this.contactListTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".contact-list-table"),
            data: this.company.contacts.models,
            isHideSearch: true,
            paging: false,
            scrollY: "400px",
            scrollCollapse: true,
            rowId: "cid",
            rowCallback: function (row, data) {
                if (data.get('isBlacklisted')) {
                    $(row).find('td').css('text-decoration', 'line-through');
                }
            },
            order: [2, 'desc'],
            language: {
                zeroRecords: 'Click "New Contact" to create a new Contact'
            },
            createdRow: _.bind(function (row, data) {
                if (data.get('contactId') === this.options.contactId || data.id === this.options.contactId) {
                    if (this.options.contactId == null && data.get('contactName') === '') {
                        $(row).addClass('bg-primary-transparent');
                    } else if (this.options.contactId != null) {
                        $(row).addClass('bg-primary-transparent');
                    }
                }
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.contactSwitched(row.data().id);
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: _.bind(function (row) {
                            return row.data().get('masterUserId') === 39 || !this.options.canEdit ? 'View' : 'Edit'
                        }, this),
                        onClick: _.bind(function (row) {
                            this.contactSwitched(row.data().id);
                        }, this)
                    },
                    {
                        name: 'Set as Primary',
                        onClick: _.bind(function (row) {
                            this.setPrimary(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteContact(row)
                        }, this),
                        isShown: _.bind(function (row) {
                            let isDirectoryContact = row.data().get('masterUserId') === 39
                            return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "title": "",
                    "data": "attributes.isPrimary",
                    "render": function (data) {
                        return data ? '<i class="fal fa-crown mr-1"></i>' : '';
                    }
                },
                {
                    "title": "Contact Name",
                    "data": "attributes.contactName"
                },
                {
                    "data": "attributes.phone",
                    "title": "Phone",
                    "width": "150px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                            phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                        if (row.get('phone') !== '')
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                        html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
                        html += '</div>';
                        return html;
                    }, this)
                },
                {
                    "title": "Email",
                    "data": "attributes.email"
                },
                {
                    "title": "Trades",
                    "data": "attributes.groups",
                    "width": "200px",
                    "render": function (data, type, row) {
                        if (_.size(row.groups.models) > 0) {
                            let groupNames = [];
                            _.each(row.groups.models, function (group) {
                                groupNames.push(group.get('groupName'));
                            });
                            if (_.size(groupNames) > 5) {
                                return _.rest(groupNames.reverse(), _.size(groupNames) - 5).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupNames) - 5) + " more item(s)</a>"
                            } else {
                                return groupNames.join(', ')
                            }
                        }
                        return '';
                    }
                },
                {
                    "data": "id",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '200px',
                    "render": _.bind(function (data, type, row) {
                        let isDirectoryContact = row.get('masterUserId') === 39;
                        let html = '<div class="show-on-row-hover text-align-right">';
                        if (!isDirectoryContact && this.options.canEdit) {
                            if (!row.get('isPrimary')) {
                                html += '<button type="button" class="btn btn-success btn-set-primary-contact mr-1" title="Set as Primary Contact"><span class="fal fa-crown"></span></button>';
                            }
                            if (data != null) {
                                html += '<button type="button" class="btn btn-primary btn-copy-contact mr-1" title="Copy Contact"><span class="fal fa-copy"></span></button>';
                            }
                            if (this.model.id !== data) {
                                html += '<button type="button" class="btn btn-info btn-edit-contact mr-1" title="Edit Contact"><i class="fal fa-pencil"></i></button>';
                            }
                            html += '<button type="button" class="btn btn-dark btn-contact-permissions mr-1" title="Permissions"><span class="fal fa-key"></span></button>';
                            if (PJQ.app.session.hasPermission('contacts.canDelete')) {
                                html += '<button type="button" class="btn btn-danger btn-delete-contact" title="Delete Contact"><i class="fal fa-trash"></i></button>';
                            }
                        } else {
                            html += '<button type="button" class="btn btn-info btn-edit-contact" title="View Contact"><i class="fal fa-search"></i></button>';
                        }
                        html += '</div>';
                        return html;
                    }, this)
                }
            ]
        });
    },
    viewEditHistory: function () {
        this.model.fetchEditHistory(function (editHistory) {
            new PJQ.views.addressbook.EditHistoryModal({
                history: editHistory
            });
        });
    },
    isActiveClicked: function (e) {
        if (!this.options.canEdit) {
            return;
        }

        let button = this.$('.btn-company-active'),
            contactButton = this.$('.btn-contact-active')
        if (!button[0].checked) {
            new PJQ.views.modals.YesNo({
                header: "Set company to inactive?",
                body: "Marking the company as inactive will also make all contacts in this company inactive.  Mark as inactive?",
                onYes: _.bind(function () {
                    this.company.set('isBlacklisted', !button[0].checked);
                    this.model.set('isBlacklisted', !button[0].checked);
                    contactButton[0].checked = false;
                }, this),
                onNo: _.bind(function () {
                    button[0].checked = true;
                })
            })
        } else {
            this.company.set('isBlacklisted', !button[0].checked);
        }

    },
    checkIsPrimary: function () {
        let button = this.$('.btn-contact-active'),
            companyButton = this.$('.btn-company-active')
        if (!button[0].checked && _.size(_.filter(this.company.contacts.models, _.bind(function (model) {
            return !model.get('isBlacklisted') && model.get('contactId') !== this.model.get('contactId');
        }, this))) >= 1 && this.model.get('isPrimary')) {
            new PJQ.views.addressbook.SelectNewPrimaryContactModal({
                contacts: this.company.contacts,
                currentPrimary: this.model,
                onSave: _.bind(function (model) {
                    model.set('isPrimary', true);
                    model.save(null, {
                        success: _.bind(function () {
                            this.model.set('isBlacklisted', true);
                            this.model.set('isPrimary', false);
                            this.model.save(null, {
                                success: _.bind(function () {
                                    this.model = model;
                                    this.setContextContact(this.model.get('contactId'));
                                }, this)
                            });
                        }, this)
                    })
                }, this),
                onCancel: _.bind(function () {
                    button[0].checked = true;
                }, this)
            })
        } else if (!button[0].checked && _.size(_.filter(this.company.contacts.models, _.bind(function (model) {
            return !model.get('isBlacklisted') && model.get('contactId') !== this.model.get('contactId');
        }, this))) <= 1 && this.model.get('isPrimary')) {
            new PJQ.views.modals.YesNo({
                header: "Set contact to inactive?",
                body: "This contact is the last remaining active contact in this company.  Marking the contact as inactive will also set the company as inactive.  Would you like to continue?",
                onYes: _.bind(function () {
                    this.company.set('isBlacklisted', !button[0].checked);
                    this.model.set('isBlacklisted', !button[0].checked);
                    companyButton[0].checked = false;
                    this.saveCompanyContact();
                    this.render();
                }, this),
                onNo: _.bind(function () {
                    button[0].checked = true;
                })
            })
        }
    },
    contactSwitchedClicked: function (e) {
        we
        let target = $(e.currentTarget),
            row = this.contactListTable.getRow(target.closest('tr'))
        this.contactSwitched(row.data().id);
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.contactListTable.getRow(target.closest('tr')),
            data = row.data(),
            groups = [];
        _.each(data.groups.models, function (group) {
            groups.push(group.get('groupName'));
        });
        target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
    },
    setPrimaryClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.contactListTable.getRow(target.closest('tr')),
            data = row.data();
        this.setPrimary(data);
    },
    setPrimary: function (data) {
        _.each(this.company.contacts.models, function (contact) {
            contact.set('isPrimary', false);
        });
        if (data == null || this.model.get('contactId') === data.get('contactId')) {
            this.model.set('isPrimary', true);
            this.model.save(null, {
                success: _.bind(function () {
                    this.contactListTable.render();
                    this.renderContact();
                }, this)
            });
        } else {
            this.model.set('isPrimary', false);
            data.set('isPrimary', true);
            data.save(null, {
                success: _.bind(function () {
                    this.contactListTable.render();
                    this.renderContact();
                }, this)
            });
        }
    },
    addNewContactClicked: function () {
        if (this.model.isNew()) {
            new PJQ.views.modals.YesNo({
                header: "Save Contact?",
                body: "You are already editing a new contact. Would you like to save this contact and start a new one?",
                onYes: _.bind(function () {
                    if (this.contactValidation()) {
                        this.saveCompanyContact(null, _.bind(function () {
                            this.addNewContact();
                        }, this));
                    }
                }, this)
            })
        } else {
            this.addNewContact();
        }
    },
    addNewContact: function () {
        let newContact = new PJQ.models.contacts.Contact({
            contactName: "",
            contactCompanyId: this.company.id ? this.company.id : 0,
            userTypeId: this.company.get('userTypeId') ? this.company.get('userTypeId') : null,
            title: "",
            address1: "",
            address2: "",
            city: "",
            zip: "",
            state: "",
            country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US',
            phone: "",
            cell: "",
            fax: "",
            email: "",
            notes: ""
        });
        this.company.contacts.add(newContact);
        this.contactListTable.addRow(newContact);
        this.model = newContact;
        this.options.contactId = newContact.id;
        this.renderContact();
        this.setContextContact(null, newContact);
    },
    copyContactClicked: function () {
        if ((this.model.isNew() || this.model.hasChanged())) {
            if (this.contactValidation()) {
                this.saveCompanyContact(null, _.bind(function () {
                    this.copyContact();
                }, this));
            }
        } else {
            this.copyContact();
        }
    },
    copyContact: function () {
        this.model.copyContact(_.bind(function (model) {
            this.options.contactId = model.contactId;
            this.model = new PJQ.models.contacts.Contact(model);
            this.company.contacts.add(this.model);
            this.contactListTable.addRow(this.model);
            this.company.fetch({
                success: _.bind(function () {
                    this.renderContact(this.options.contactId);
                    this.setContextContact(this.model.id);
                }, this)
            })
        }, this))
    },
    cancel: function () {
        if ((this.model.isDirty || this.company.isDirty) && this.options.canEdit && !this.model.get('isApprovalRequired')) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                }, this)
            });
        } else {
            if (typeof this.options.onCancel === 'function') {
                this.options.onCancel(this.model);
            }
            if (this.options.modal != null) {
                this.options.modal.removeModal();
            }
        }
    },
    delete: function () {
        let message = "Are you sure you want to delete this company?";
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: message,
            onDelete: _.bind(function () {
                this.company.destroy();
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.company);
                }
            }, this)
        });
    },
    deleteContactClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.contactListTable.getRow(target.closest('tr'));
        this.deleteContact(row);
    },
    deleteContact: function (row) {
        let contact = row.data();
        let message = "Are you sure you want to delete this contact?";
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: message,
            onDelete: _.bind(function () {
                this.company.contacts.remove(contact);
                contact.destroy();
                this.contactListTable.removeRow(row);
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }, this)
        });
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    save: function (callback) {
        this.company.set({
            notes: this.$('.company-edit-notes').val(),
            companyName: this.$('.company-edit-name').val()
        });
        if (this.companyValidation() && this.contactValidation()) {
            this.saveCompanyContact(false, _.bind(function (success) {
                if (success) {
                    this.options.onSave(this.model);
                }

                if(typeof callback === 'function'){
                    callback();
                }
            }, this));
        }
    },
    companyValidation: function () {
        let $company = this.$('.company-edit-name'),
            scrollTopError = $('.validation-error').offset().top,
            hasCompanyError = false,
            companyNameValue = this.$('.company-edit-name').val();

        PJQ.helpers.inputHelpers.setInputError($company, true);
        if (_.size(companyNameValue) === 0) {
            PJQ.helpers.inputHelpers.setInputError($company, false);
            hasCompanyError = true;
        }

        if (this.options.canEditCustomFields) {
            if (this.companyCustomFieldsForm) {
                if (!this.companyCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditCompanyCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasCompanyError = true;
                }
            }
        }
        if (hasCompanyError) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: 'Required fields are empty or have an incorrect value'
            });

            $('div.modal').animate({
                scrollTop: scrollTopError
            }, 500);
            return false
        } else {
            this.$('.validation-error').empty();
            return true
        }
    },
    saveCompany: function (callback = _.noop) {
        if (this.company.id === this.model.id) {
            callback(true);
            return;
        }

        let $companyName = this.$('.company-edit-name'),
            $notes = this.$('.company-edit-notes');
        this.company.set({
            companyName: _.size($companyName) > 0 ? $companyName.val() : this.company.get('companyName'),
            notes: _.size($notes) > 0 ? $notes.val() : this.company.get('notes')
        });
        if (this.company.hasChanged()) {
            this.company.save({
                companyName: _.size($companyName) > 0 ? $companyName.val() : this.company.get('companyName'),
                notes: _.size($notes) > 0 ? $notes.val() : this.company.get('notes')
            }, {
                success: _.bind(function (model) {
                    callback(true);
                }, this),
                error: _.bind(function (model, response) {
                    callback(true);
                }, this)
            });
        }
    },
    contactValidation: function () {
        let hasError = false,
            $scrollTo = null;
        //only validate core contact information if they can actually edit it
        //they may only be able to edit the custom fields
        if (this.options.canEdit) {
            let validate = this.validateCoreFields();
            if (!validate.valid) {
                hasError = true;
                $scrollTo = validate.$scrollTo;
            }

            if (this.model instanceof PJQ.models.users.User && this.model.isNew()) {
                let $username = this.$('.input-username');
                PJQ.helpers.inputHelpers.setInputError($username, true);
                if (_.size(this.model.get('username')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($username, false);
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = $username;
                    }
                }

                let $password = this.$('.input-password');
                PJQ.helpers.inputHelpers.setInputError($password, true);
                if (_.size(this.model.get('password')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($password, false);
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = $password;
                    }
                }
            }
        }

        if (this.options.canEditCustomFields) {
            if (this.contactCustomFieldsForm) {
                if (!this.contactCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditContactCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.contactCustomFieldsForm.$el;
                    }
                }
            }
        }

        if (hasError) {
            new PJQ.Alert(this.$('.validation-error-contact'), {
                type: 'danger',
                text: 'Required fields are empty or have an incorrect value'
            });

            if (_.size($scrollTo) > 0) {
                $('div.modal').animate({
                    scrollTop: $scrollTo.offset().top
                }, 500);
            }
        } else {
            this.$('.validation-error-contact').empty();
        }
        return !hasError;
    },
    mirrorTrades: function () {
        new PJQ.views.modals.YesNo({
            header: "Mirror Confirmation",
            body: "Are you sure you want to mirror Trades from this contact to all contacts in this company?",
            onYes: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts',
                            value: this.model.id
                        },
                        {
                            endpoint: 'mirrortrades'
                        },
                    ])
                }).post().done(_.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Trades successfully mirrored'
                    });
                    this.company.fetch({
                        success: _.bind(function () {
                            this.render();
                            this.renderContactsTable()
                        }, this)
                    })
                }, this)).fail(function (xhr, err, result) {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Something went wrong!'
                    });
                });
            }, this)
        })
    },
    saveCompanyContact: function (isAddToProject, callback = _.noop) {
        if (!(this.model instanceof PJQ.models.users.User || this.model.id < 0)) {
            if (this.groupSelector != null) {
                this.model.groups.reset(this.groupSelector.getGroupsData().all);
            }
        }

        let loader = new PJQ.Loader(this.$('.modal-content')),
            isNew = this.model.isNew();
        if (this.model.get('isApprovalRequired')) {
            this.model.approve(_.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Successfully approved contact'
                });
                loader.remove();
                callback(true);
            }, this))
        } else {
            this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
            this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
            let isContactNew = this.model.isNew();
            this.model.save(null, {
                notify: false,
                success: _.bind(function (model) {
                    let fnContinue = _.bind(function () {
                        let ccId = model.get('contactCompanyId');
                        this.company.set({
                            id: ccId,
                            contactId: ccId
                        });
                        _.each(this.company.models, function (mod) {
                            mod.set('contactCompanyId', ccId);
                        });
                        this.saveCompany(_.bind(function () {
                            let message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
                            if (this.options.isSelfEdit) {
                                message = 'Successfully saved your info'
                            } else {
                                if (this.model instanceof PJQ.models.users.User) {
                                    if (isNew) {
                                        PJQ.app.session.users.add(this.model);
                                        message = 'Successfully added user';
                                    } else {
                                        message = 'Successfully saved user';
                                    }
                                }
                            }
                            PJQ.notifications.notify.successNotify({
                                message: message
                            });
                            loader.remove();

                            callback(true);
                        }, this));
                    }, this);

                    if (typeof this.options.onSaveContact === 'function') {
                        if (isContactNew && _.size(this.model.get('groups')) > 0) {
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'contacts'
                                    },
                                    {
                                        endpoint: 'contactgroupids'
                                    }
                                ], [
                                    {
                                        parameter: 'contactIds',
                                        value: this.model.get('contactId')
                                    }
                                ])
                            }).get().done(_.bind(function (response) {
                                this.model.set('contactGroups', response.contactGroupIds);
                                this.options.onSaveContact(this.model, isContactNew);
                                fnContinue();
                            }, this));
                        } else {
                            this.options.onSaveContact(this.model, isContactNew);
                            fnContinue();
                        }
                    }

                }, this),
                error: _.bind(function (model, response) {
                    if (response.responseJSON && response.responseJSON.message && response.responseJSON.message === 'EmailExists') {
                        new PJQ.views.BaseModal({
                            header: "Email Exists",
                            body: "Another contact in your Address Book has this email address already.   Do you still want to save this record?",
                            okButtonText: 'Yes',
                            secondaryButtonText: 'Go to Contact',
                            isShowCancelButton: true,
                            isShowSecondaryButton: true,
                            onOk: _.bind(function () {
                                loader.remove();
                                this.model.set('isForceSaveExistingEmail', true);
                                this.saveCompanyContact(isAddToProject, callback);
                            }, this),
                            onSecondary: _.bind(function () {
                                new PJQ.ajax.Request({
                                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                        {
                                            endpoint: 'contacts'
                                        },
                                        {
                                            endpoint: 'email'
                                        }
                                    ], [
                                        {
                                            parameter: 'email',
                                            value: this.model.get('email')
                                        }
                                    ])
                                }).get().done(_.bind(function (data) {
                                    this.company = new PJQ.models.contacts.Company(data);
                                    let contact = _.find(data.contacts, function (contact) {
                                        return contact.email === this.model.get('email');
                                    }, this)
                                    this.options.contactId = contact.contactId;
                                    this.render();
                                }, this)).fail(function (xhr, err, result) {
                                    PJQ.notifications.notify.errorNotify({
                                        message: 'Something went wrong!'
                                    });
                                });
                            }, this)
                        });
                    } else {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to save'
                        });
                        callback(false);
                    }
                }, this)
            });
        }
    },
    viewPrequalAuditLog: function (e) {
        e.stopPropagation();
        new PJQ.views.prequal.PrequalAuditLogModal({
            contactId: this.model.get('contactId')
        });
    }
});

PJQ.views.addressbook.EditCompanyModal = PJQ.views.contacts.BaseEditContactModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Edit-Company'),
        canEdit: true,
        minWidth: 600,
        maxWidth: 1200,
        alert: null,
        onDelete: _.noop,
        onCancel: _.noop,
        onSave: _.noop,
        onSaveContact: _.noop,
        isShowCloseButton: true
    },
    events: {
        'click .btn-bid-history': 'viewBidHistory',
        'click .btn-edit-history': 'viewEditHistory',
        "click .contact-edit-cancel": "cancel",
        "click .contact-edit-save": "save",
        "click .contact-edit-delete": "delete"
    },
    beforeModalCreated: function () {
        this.company = this.options.company;

        if (this.company == null) {
            this.company = new PJQ.models.contacts.Company({
                id: this.options.contactCompanyId ? this.options.contactCompanyId : this.options.contactId
            });
        }

        if (!this.company.isNew() && !this.company.isFetched) {
            this.company.fetch({
                success: _.bind(function () {
                    this.render();
                }, this)
            });
        } else {
            this.render();
        }
    },
    getContactElement: function () {
        return this.$('.contact-edit');
    },
    shouldRenderInnerView: function () {
        return this.company != null && (this.company.isNew() || this.company.isFetched);
    },
    renderData: function () {
        return {
            company: this.company,
            canEditCustomFields: this.options.canEditCustomFields,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
        };
    },
    getInnerViewType: function () {
        return PJQ.views.addressbook.EditCompanyView;
    },
    getInnerViewOptions: function () {
        return {
            company: this.company,
            model: this.options.model,
            contactId: this.options.contactId,
            contactCompanyId: this.options.contactCompanyId,
            onCompanySave: this.options.onSave,
            onDelete: this.options.onDelete,
            onSaveContact: this.options.onSaveContact,
            closeModal: _.bind(function () {
                this.removeModal();
            }, this)
        };
    },
    viewEditHistory: function () {
        this.editView.viewEditHistory();
    },
    viewBidHistory: function () {
        this.editView.viewBidHistory();
    }
});

PJQ.views.addressbook.ApproveAddressBookContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-contact-approval'),
        minWidth: 600,
        maxWidth: "60%",
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .approval-save': 'approveClicked',
        'click .input-approve-status': 'approvalStatusChanged',
        'change .input-approve-all': 'approveAll'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (!PJQ.app.session.hasPermission('contacts.canApprove')) {
            this.$('.approval-save').hide();
        }
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-merge-company'),
            noneSelectedText: 'Select Merge Company',
            hideDisabled: false,
            onChange: _.bind(function (value) {
                this.model.set('contactCompanyId', value);
            }, this)
        });
        this.renderDataTable();
    },
    renderDataTable: function () {
        let hasUnapproved = null != _.find(this.model.approvalUpdates.models, function (update) {
            return !update.get('isApproved');
        });
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".approval-updates-table"),
            data: this.model.approvalUpdates.models,
            rowId: "cid",
            paging: false,
            isHideSearch: true,
            order: [0, 'asc'],
            language: {
                zeroRecords: 'No Approvals Pending'
            },
            columns: [
                {
                    "title": "Field",
                    "data": "attributes.fieldLabel"
                },
                {
                    "title": "Old Value",
                    "data": "attributes.oldValueDisplay"
                },
                {
                    "title": "New Value",
                    "data": "attributes.newValueDisplay"
                },
                {
                    "title": '<div class="pretty p-switch p-fill p-toggle mt-2"><input type="checkbox" class="input-approve-all" ' + (hasUnapproved ? '' : 'checked') + '><div class="state p-success"><label>&nbsp;</label></div></div>',
                    "data": "attributes.isApproved",
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        return "<div class=\"form-group\">\n" +
                            "        <div>\n" +
                            "            <div class=\"pretty p-switch p-fill p-toggle mt-3\">\n" +
                            "                  <input type=\"checkbox\" class=\"input-approve-status\" data-cid='" + row.cid + "' " + (row.get('isApproved') ? "checked" : "") + "/>\n" +
                            "                <div class=\"state p-success\">\n" +
                            // " &#8205; " is an invisible character. If there is no label the switch's positioning messes up.
                            "                    <label><span class=\"fs-16\">&#8205;</span></label>\n" +
                            "                </div>\n" +
                            "            </div>\n" +
                            "        </div>\n" +
                            "    </div>"
                    }, this)
                }
            ]
        });
    },
    approvalStatusChanged: function (e) {
        let cid = e.target.dataset.cid,
            value = e.target.checked,
            model = this.model.approvalUpdates.get(cid);
        model.set('isApproved', value);
        this.updateApproveAllInput();
    },
    approveClicked: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.approve(_.bind(function (success) {
            if (success) {
                loader.remove();
                this.removeModal();
                PJQ.notifications.notify.successNotify({
                    message: 'Successfully approved contact'
                });
                this.options.onSave(this.model);
            }
        }, this));
    },
    approve: function (callback = _.noop) {
        this.model.approve(_.bind(function () {
            if (this.options.onApprove) {
                this.options.onApprove(this.model);
            }
            callback(true);
        }, this));
    },
    approveAll: function (e) {
        let isApproved = $(e.currentTarget).prop('checked');
        _.each(this.model.approvalUpdates.models, function (update) {
            update.set('isApproved', isApproved);
        });
        this.renderDataTable();
    },
    updateApproveAllInput: function () {
        let hasUnapproved = null != _.find(this.model.approvalUpdates.models, function (update) {
            return !update.get('isApproved');
        });
        this.$('.input-approve-all').prop('checked', !hasUnapproved);
    },
});

PJQ.views.addressbook.EditHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-history-modal'),
        subTemplates: {
            history: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-history'),
        },
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {},
    afterRender: function () {
        this.renderHistory()
    },
    renderHistory: function () {
        this.renderSubTemplate(false, this.options.subTemplates.history, this.$('.history-outer'), {
            history: this.options.history.models
        });
    }
});

PJQ.views.addressbook.SelectNewPrimaryContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'select-primary-contact-modal'),
        subTemplates: {
            contacts: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'primary-contact'),
        },
        width: '50%',
        maxWidth: 500,
        onSave: _.noop
    },
    events: {
        "click .primary-contact-card": "contactClicked",
        "click .btn-save": "savePrimary",
        "click .btn-cancel": "cancel"
    },
    afterRender: function () {
        this.renderContacts();
    },
    renderContacts: function () {
        this.renderSubTemplate(false, this.options.subTemplates.contacts, this.$('.contacts-outer'), {
            contacts: this.options.contacts.models,
            currentPrimary: this.options.currentPrimary
        });
    },
    contactClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.data('cid');
        this.newPrimary = this.options.contacts.get(cid);
        $('.primary-contact-card').removeClass('selected');
        target.addClass('selected');

        if (this.newPrimary) {
            this.$('.btn-save').attr('disabled', false);
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    savePrimary: function () {
        if (this.options.onSave) {
            this.options.onSave(this.newPrimary);
            this.removeModal();
        }
    }
});
